var _font;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 568 151.467"
    },
    xmlSpace: "preserve",
    viewBox: "22.88 15.65 490.79 120.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _font || (_font = /*#__PURE__*/React.createElement("font", {
    horizAdvX: 1000
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Causten-ExtraLight",
    unitsPerEm: 1000,
    underlinePosition: -100,
    underlineThickness: 50
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 475,
    d: "M390,750l-302,0l0,-950l302,0M316,686l0,-31l-62,0l0,-35l62,0l0,-31l-157,0l0,31l62,0l0,35l-61,0l0,31M254,564l0,-67l62,0l0,-32l-157,0l0,99M221,532l-31,0l0,-35l31,0M316,439l0,-31l-62,0l0,-66l-95,0l0,31l62,0l0,35l-62,0l0,31M316,382l0,-95l-157,0l0,33l126,0l0,62M316,266l0,-107l-157,0l0,107l31,0l0,-76l95,0l0,45l-31,0l0,-22l-33,0l0,53M316,102l0,-107l-157,0l0,107M285,71l-95,0l0,-45l95,0M316,-27l0,-31l-30,0l-67,-45l97,0l0,-31l-157,0l0,31l66,45l-66,0l0,31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "A",
    horizAdvX: 636,
    d: "M556,0l42,0l-269,650l-32,0l-269,-650l42,0l81,195l324,0M166,233l147,355l147,-355z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC6",
    horizAdvX: 949,
    d: "M512,612l364,0l0,38l-577,0l-271,-650l42,0l127,305l275,0l0,-305l404,0l0,38l-364,0l0,267l343,0l0,38l-343,0M213,343l111,269l148,0l0,-269z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC1",
    horizAdvX: 636,
    d: "M335,798l-41,-88l36,0l44,88M556,0l42,0l-269,650l-32,0l-269,-650l42,0l81,195l324,0M166,233l147,355l147,-355z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0102",
    horizAdvX: 636,
    d: "M389,788l-29,0l0,-3C360,759 342,737 313,737C283,737 265,759 265,785l0,3l-29,0l0,-3C236,740 271,709 313,709C355,709 389,740 389,785M556,0l42,0l-269,650l-32,0l-269,-650l42,0l81,195l324,0M166,233l147,355l147,-355z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC2",
    horizAdvX: 636,
    d: "M392,710l-55,88l-49,0l-55,-88l38,0l42,68l41,-68M556,0l42,0l-269,650l-32,0l-269,-650l42,0l81,195l324,0M166,233l147,355l147,-355z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC4",
    horizAdvX: 636,
    d: "M226,707C240,707 253,718 253,734C253,749 240,759 226,759C213,759 200,749 200,734C200,718 213,707 226,707M399,707C413,707 426,718 426,734C426,749 413,759 399,759C386,759 373,749 373,734C373,718 386,707 399,707M556,0l42,0l-269,650l-32,0l-269,-650l42,0l81,195l324,0M166,233l147,355l147,-355z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC0",
    horizAdvX: 636,
    d: "M292,798l-40,0l45,-88l35,0M556,0l42,0l-269,650l-32,0l-269,-650l42,0l81,195l324,0M166,233l147,355l147,-355z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0100",
    horizAdvX: 636,
    d: "M234,740l0,-30l158,0l0,30M556,0l42,0l-269,650l-32,0l-269,-650l42,0l81,195l324,0M166,233l147,355l147,-355z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0104",
    horizAdvX: 636,
    d: "M543,-50C543,-28 558,-11 571,0l27,0l-269,650l-32,0l-269,-650l42,0l81,195l324,0l78,-187C534,-3 512,-26 512,-54C512,-79 533,-109 588,-93l0,29C554,-78 543,-65 543,-50M166,233l147,355l147,-355z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC5",
    horizAdvX: 636,
    d: "M313,702C350,702 380,730 380,770C380,812 350,839 313,839C276,839 245,812 245,770C245,730 276,702 313,702M313,727C287,727 272,749 272,770C272,791 287,813 313,813C339,813 353,791 353,770C353,749 339,727 313,727M556,0l42,0l-269,650l-32,0l-269,-650l42,0l81,195l324,0M166,233l147,355l147,-355z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC3",
    horizAdvX: 636,
    d: "M187,710l29,0C217,734 230,757 257,757C276,757 290,746 303,732C317,716 335,698 368,698C412,698 436,730 438,774l-29,0C408,749 398,727 368,727C345,727 332,742 321,754C306,771 286,786 257,786C218,786 189,753 187,710M556,0l42,0l-269,650l-32,0l-269,-650l42,0l81,195l324,0M166,233l147,355l147,-355z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "B",
    horizAdvX: 603,
    d: "M441,338C495,363 530,413 530,483C530,586 454,650 354,650l-296,0l0,-650l319,0C477,0 554,73 554,176C554,256 508,315 441,338M97,612l253,0C435,612 490,559 490,482C490,404 435,352 350,352l-253,0M373,38l-276,0l0,278l276,0C458,316 514,255 514,177C514,100 459,38 373,38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "C",
    horizAdvX: 692,
    d: "M602,505l33,22C579,608 487,658 372,658C179,658 48,518 48,325C48,132 179,-8 372,-8C487,-8 579,42 635,123l-33,23C554,77 473,32 372,32C202,32 87,156 87,325C87,494 202,618 372,618C473,618 554,574 602,505z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0106",
    horizAdvX: 692,
    d: "M392,800l-41,-88l36,0l44,88M602,505l33,22C579,608 487,658 372,658C179,658 48,518 48,325C48,132 179,-8 372,-8C487,-8 579,42 635,123l-33,23C554,77 473,32 372,32C202,32 87,156 87,325C87,494 202,618 372,618C473,618 554,574 602,505z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u010C",
    horizAdvX: 692,
    d: "M411,800l-41,-68l-42,68l-38,0l55,-88l49,0l55,88M602,505l33,22C579,608 487,658 372,658C179,658 48,518 48,325C48,132 179,-8 372,-8C487,-8 579,42 635,123l-33,23C554,77 473,32 372,32C202,32 87,156 87,325C87,494 202,618 372,618C473,618 554,574 602,505z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC7",
    horizAdvX: 692,
    d: "M372,32C202,32 87,156 87,325C87,494 202,618 372,618C473,618 554,574 602,505l33,22C579,608 487,658 372,658C179,658 48,518 48,325C48,138 171,1 354,-8l-18,-30l-1,0l0,-26C341,-60 352,-59 360,-59C383,-59 398,-69 398,-82C398,-96 383,-105 365,-105C350,-105 335,-104 323,-94l0,-30C337,-130 351,-132 365,-132C409,-132 426,-106 426,-82C426,-61 410,-37 368,-34l15,26C493,-5 581,45 635,123l-33,23C554,77 473,32 372,32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u010A",
    horizAdvX: 692,
    d: "M370,709C384,709 397,720 397,736C397,751 384,761 370,761C357,761 344,751 344,736C344,720 357,709 370,709M602,505l33,22C579,608 487,658 372,658C179,658 48,518 48,325C48,132 179,-8 372,-8C487,-8 579,42 635,123l-33,23C554,77 473,32 372,32C202,32 87,156 87,325C87,494 202,618 372,618C473,618 554,574 602,505z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "D",
    horizAdvX: 648,
    d: "M264,650l-206,0l0,-650l206,0C457,0 586,132 586,325C586,518 457,650 264,650M264,39l-167,0l0,572l167,0C426,611 546,501 546,325C546,149 426,39 264,39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u010E",
    horizAdvX: 648,
    d: "M299,799l-41,-68l-42,68l-38,0l55,-88l49,0l55,88M264,650l-206,0l0,-650l206,0C457,0 586,132 586,325C586,518 457,650 264,650M264,39l-167,0l0,572l167,0C426,611 546,501 546,325C546,149 426,39 264,39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0110",
    horizAdvX: 649,
    d: "M265,650l-207,0l0,-309l-57,0l0,-38l57,0l0,-303l207,0C458,0 587,132 587,325C587,518 458,650 265,650M265,40l-168,0l0,263l153,0l0,38l-153,0l0,269l168,0C426,610 547,500 547,325C547,150 426,40 265,40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "E",
    horizAdvX: 538,
    d: "M466,612l0,38l-408,0l0,-650l408,0l0,38l-369,0l0,267l348,0l0,38l-348,0l0,269z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC9",
    horizAdvX: 538,
    d: "M291,798l-41,-88l36,0l44,88M466,612l0,38l-408,0l0,-650l408,0l0,38l-369,0l0,267l348,0l0,38l-348,0l0,269z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u011A",
    horizAdvX: 538,
    d: "M310,798l-41,-68l-42,68l-38,0l55,-88l49,0l55,88M466,612l0,38l-408,0l0,-650l408,0l0,38l-369,0l0,267l348,0l0,38l-348,0l0,269z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xCA",
    horizAdvX: 538,
    d: "M348,710l-55,88l-49,0l-55,-88l38,0l42,68l41,-68M466,612l0,38l-408,0l0,-650l408,0l0,38l-369,0l0,267l348,0l0,38l-348,0l0,269z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xCB",
    horizAdvX: 538,
    d: "M182,707C196,707 209,718 209,734C209,749 196,759 182,759C169,759 156,749 156,734C156,718 169,707 182,707M355,707C369,707 382,718 382,734C382,749 369,759 355,759C342,759 329,749 329,734C329,718 342,707 355,707M466,612l0,38l-408,0l0,-650l408,0l0,38l-369,0l0,267l348,0l0,38l-348,0l0,269z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0116",
    horizAdvX: 538,
    d: "M269,707C283,707 296,718 296,734C296,749 283,759 269,759C256,759 243,749 243,734C243,718 256,707 269,707M466,612l0,38l-408,0l0,-650l408,0l0,38l-369,0l0,267l348,0l0,38l-348,0l0,269z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC8",
    horizAdvX: 538,
    d: "M248,798l-40,0l45,-88l35,0M466,612l0,38l-408,0l0,-650l408,0l0,38l-369,0l0,267l348,0l0,38l-348,0l0,269z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0112",
    horizAdvX: 538,
    d: "M190,740l0,-30l158,0l0,30M466,612l0,38l-408,0l0,-650l408,0l0,38l-369,0l0,267l348,0l0,38l-348,0l0,269z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0118",
    horizAdvX: 538,
    d: "M466,612l0,38l-408,0l0,-650l365,0C404,-12 384,-34 384,-61C384,-86 405,-116 460,-100l0,29C426,-85 415,-72 415,-57C415,-30 439,-9 452,0l14,0l0,38l-369,0l0,267l348,0l0,38l-348,0l0,269z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u20AC",
    horizAdvX: 599,
    d: "M473,620C483,620 512,620 522,619l0,38C512,658 479,658 469,658C315,658 212,568 178,432l-120,0l0,-29l114,0C167,378 165,352 165,325C165,298 167,272 172,247l-114,0l0,-29l120,0C212,82 315,-8 469,-8C479,-8 512,-8 522,-7l0,38C512,30 483,30 473,30C343,30 252,102 218,218l251,0l0,29l-258,0C206,271 204,298 204,325C204,352 206,379 211,403l258,0l0,29l-251,0C252,548 343,620 473,620z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "F",
    horizAdvX: 535,
    d: "M466,611l0,39l-408,0l0,-650l39,0l0,302l350,0l0,38l-350,0l0,271z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "G",
    horizAdvX: 752,
    d: "M684,310l0,15l-313,0l0,-38l270,0C628,136 527,32 372,32C202,32 87,156 87,325C87,494 202,618 372,618C470,618 551,576 601,506l34,22C579,608 487,658 372,658C179,658 48,518 48,325C48,132 179,-8 372,-8C560,-8 678,125 684,310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0393",
    horizAdvX: 464,
    d: "M386,650l-328,0l0,-650l39,0l0,612l289,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u011E",
    horizAdvX: 752,
    d: "M452,788l-29,0l0,-3C423,759 405,737 376,737C346,737 328,759 328,785l0,3l-29,0l0,-3C299,740 334,709 376,709C418,709 452,740 452,785M684,310l0,15l-313,0l0,-38l270,0C628,136 527,32 372,32C202,32 87,156 87,325C87,494 202,618 372,618C470,618 551,576 601,506l34,22C579,608 487,658 372,658C179,658 48,518 48,325C48,132 179,-8 372,-8C560,-8 678,125 684,310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u01E6",
    horizAdvX: 752,
    d: "M417,798l-41,-68l-42,68l-38,0l55,-88l49,0l55,88M684,310l0,15l-313,0l0,-38l270,0C628,136 527,32 372,32C202,32 87,156 87,325C87,494 202,618 372,618C470,618 551,576 601,506l34,22C579,608 487,658 372,658C179,658 48,518 48,325C48,132 179,-8 372,-8C560,-8 678,125 684,310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0120",
    horizAdvX: 752,
    d: "M376,707C390,707 403,718 403,734C403,749 390,759 376,759C363,759 350,749 350,734C350,718 363,707 376,707M684,310l0,15l-313,0l0,-38l270,0C628,136 527,32 372,32C202,32 87,156 87,325C87,494 202,618 372,618C470,618 551,576 601,506l34,22C579,608 487,658 372,658C179,658 48,518 48,325C48,132 179,-8 372,-8C560,-8 678,125 684,310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "H",
    horizAdvX: 617,
    d: "M499,650l0,-306l-402,0l0,306l-39,0l0,-650l39,0l0,305l402,0l0,-305l40,0l0,650z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "I",
    horizAdvX: 175,
    d: "M97,0l0,650l-39,0l0,-650z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xCD",
    horizAdvX: 175,
    d: "M99,798l-41,-88l36,0l44,88M97,0l0,650l-39,0l0,-650z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xCE",
    horizAdvX: 175,
    d: "M156,710l-55,88l-49,0l-55,-88l38,0l42,68l41,-68M97,0l0,650l-39,0l0,-650z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xCF",
    horizAdvX: 175,
    d: "M-10,707C4,707 17,718 17,734C17,749 4,759 -10,759C-23,759 -36,749 -36,734C-36,718 -23,707 -10,707M163,707C177,707 190,718 190,734C190,749 177,759 163,759C150,759 137,749 137,734C137,718 150,707 163,707M97,0l0,650l-39,0l0,-650z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0130",
    horizAdvX: 175,
    d: "M77,707C91,707 104,718 104,734C104,749 91,759 77,759C64,759 51,749 51,734C51,718 64,707 77,707M97,0l0,650l-39,0l0,-650z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xCC",
    horizAdvX: 175,
    d: "M56,798l-40,0l45,-88l35,0M97,0l0,650l-39,0l0,-650z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u012A",
    horizAdvX: 175,
    d: "M-2,740l0,-30l158,0l0,30M97,0l0,650l-39,0l0,-650z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u012E",
    horizAdvX: 175,
    d: "M55,-57C55,-30 79,-9 92,0l5,0l0,650l-39,0l0,-650l5,0C44,-12 24,-34 24,-61C24,-86 45,-116 100,-100l0,29C66,-85 55,-72 55,-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0128",
    horizAdvX: 175,
    d: "M-49,710l29,0C-19,734 -6,757 21,757C40,757 54,746 67,732C81,716 99,698 132,698C176,698 200,730 202,774l-29,0C172,749 162,727 132,727C109,727 96,742 85,754C70,771 50,786 21,786C-18,786 -47,753 -49,710M97,0l0,650l-39,0l0,-650z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "J",
    horizAdvX: 487,
    d: "M370,650l0,-478C370,94 321,31 222,31C133,31 87,79 77,143l-39,-12C53,49 115,-8 222,-8C339,-8 410,65 410,169l0,481z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "K",
    horizAdvX: 512,
    d: "M475,0l-340,325l327,325l-52,0l-313,-311l0,311l-39,0l0,-650l39,0l0,312l326,-312z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "L",
    horizAdvX: 521,
    d: "M97,38l0,612l-39,0l0,-650l406,0l0,38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0139",
    horizAdvX: 521,
    d: "M99,798l-41,-88l36,0l44,88M97,38l0,612l-39,0l0,-650l406,0l0,38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u013D",
    horizAdvX: 521,
    d: "M118,798l-41,-68l-42,68l-38,0l55,-88l49,0l55,88M97,38l0,612l-39,0l0,-650l406,0l0,38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0141",
    horizAdvX: 521,
    d: "M97,38l0,297l153,55l0,39l-153,-55l0,276l-39,0l0,-290l-57,-20l0,-39l57,20l0,-321l406,0l0,38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "M",
    horizAdvX: 733,
    d: "M656,650l-46,0l-253,-503l-253,503l-46,0l0,-650l39,0l0,579l246,-496l28,0l245,496l0,-579l40,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "N",
    horizAdvX: 616,
    d: "M499,650l0,-581l-402,581l-39,0l0,-650l40,0l0,583l402,-583l39,0l0,650z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0143",
    horizAdvX: 616,
    d: "M330,798l-41,-88l36,0l44,88M499,650l0,-581l-402,581l-39,0l0,-650l40,0l0,583l402,-583l39,0l0,650z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0147",
    horizAdvX: 616,
    d: "M349,798l-41,-68l-42,68l-38,0l55,-88l49,0l55,88M499,650l0,-581l-402,581l-39,0l0,-650l40,0l0,583l402,-583l39,0l0,650z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD1",
    horizAdvX: 616,
    d: "M182,710l29,0C212,734 225,757 252,757C271,757 285,746 298,732C312,716 330,698 363,698C407,698 431,730 433,774l-29,0C403,749 393,727 363,727C340,727 327,742 316,754C301,771 281,786 252,786C213,786 184,753 182,710M499,650l0,-581l-402,581l-39,0l0,-650l40,0l0,583l402,-583l39,0l0,650z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "O",
    horizAdvX: 757,
    d: "M372,-8C565,-8 695,132 695,325C695,518 565,658 372,658C179,658 48,518 48,325C48,132 179,-8 372,-8M372,32C202,32 87,156 87,325C87,494 202,618 372,618C543,618 655,494 655,325C655,156 543,32 372,32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0152",
    horizAdvX: 1133,
    d: "M1061,612l0,38l-402,0l0,-162C608,592 506,658 373,658C179,658 48,518 48,325C48,132 180,-8 373,-8C506,-8 608,58 659,162l0,-162l402,0l0,38l-362,0l0,267l341,0l0,38l-341,0l0,269M373,32C201,32 87,156 87,325C87,494 201,618 373,618C543,618 655,494 655,325C655,156 543,32 373,32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD3",
    horizAdvX: 757,
    d: "M394,798l-41,-88l36,0l44,88M372,-8C565,-8 695,132 695,325C695,518 565,658 372,658C179,658 48,518 48,325C48,132 179,-8 372,-8M372,32C202,32 87,156 87,325C87,494 202,618 372,618C543,618 655,494 655,325C655,156 543,32 372,32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD4",
    horizAdvX: 757,
    d: "M451,710l-55,88l-49,0l-55,-88l38,0l42,68l41,-68M372,-8C565,-8 695,132 695,325C695,518 565,658 372,658C179,658 48,518 48,325C48,132 179,-8 372,-8M372,32C202,32 87,156 87,325C87,494 202,618 372,618C543,618 655,494 655,325C655,156 543,32 372,32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD6",
    horizAdvX: 757,
    d: "M285,707C299,707 312,718 312,734C312,749 299,759 285,759C272,759 259,749 259,734C259,718 272,707 285,707M458,707C472,707 485,718 485,734C485,749 472,759 458,759C445,759 432,749 432,734C432,718 445,707 458,707M372,-8C565,-8 695,132 695,325C695,518 565,658 372,658C179,658 48,518 48,325C48,132 179,-8 372,-8M372,32C202,32 87,156 87,325C87,494 202,618 372,618C543,618 655,494 655,325C655,156 543,32 372,32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD2",
    horizAdvX: 757,
    d: "M351,798l-40,0l45,-88l35,0M372,-8C565,-8 695,132 695,325C695,518 565,658 372,658C179,658 48,518 48,325C48,132 179,-8 372,-8M372,32C202,32 87,156 87,325C87,494 202,618 372,618C543,618 655,494 655,325C655,156 543,32 372,32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0150",
    horizAdvX: 757,
    d: "M332,798l-41,-88l33,0l47,88M452,798l-41,-88l33,0l48,88M372,-8C565,-8 695,132 695,325C695,518 565,658 372,658C179,658 48,518 48,325C48,132 179,-8 372,-8M372,32C202,32 87,156 87,325C87,494 202,618 372,618C543,618 655,494 655,325C655,156 543,32 372,32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u014C",
    horizAdvX: 757,
    d: "M293,740l0,-30l158,0l0,30M372,-8C565,-8 695,132 695,325C695,518 565,658 372,658C179,658 48,518 48,325C48,132 179,-8 372,-8M372,32C202,32 87,156 87,325C87,494 202,618 372,618C543,618 655,494 655,325C655,156 543,32 372,32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD8",
    horizAdvX: 757,
    d: "M589,580l61,78l-41,0l-45,-58C512,637 447,658 372,658C179,658 48,518 48,325C48,221 86,132 152,72l-57,-72l41,0l41,52C229,14 296,-8 372,-8C565,-8 695,132 695,325C695,431 656,520 589,580M87,325C87,495 201,618 372,618C437,618 494,600 539,568l-363,-464C120,157 87,234 87,325M372,32C305,32 247,51 201,84l363,464C622,496 655,417 655,325C655,156 543,32 372,32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD5",
    horizAdvX: 757,
    d: "M246,710l29,0C276,734 289,757 316,757C335,757 349,746 362,732C376,716 394,698 427,698C471,698 495,730 497,774l-29,0C467,749 457,727 427,727C404,727 391,742 380,754C365,771 345,786 316,786C277,786 248,753 246,710M372,-8C565,-8 695,132 695,325C695,518 565,658 372,658C179,658 48,518 48,325C48,132 179,-8 372,-8M372,32C202,32 87,156 87,325C87,494 202,618 372,618C543,618 655,494 655,325C655,156 543,32 372,32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "P",
    horizAdvX: 580,
    d: "M345,650l-287,0l0,-650l39,0l0,275l248,0C444,275 523,355 523,462C523,569 444,650 345,650M341,314l-244,0l0,297l244,0C426,611 483,541 483,462C483,383 426,314 341,314z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u03A6",
    horizAdvX: 784,
    d: "M706,326C706,494 584,580 400,585l0,66l-36,0l0,-66C180,579 58,493 58,326C58,158 180,72 364,66l0,-67l36,0l0,67C584,71 706,157 706,326M97,326C97,465 198,539 364,545l0,-439C198,112 97,186 97,326M400,106l0,439C567,540 667,465 667,326C667,186 567,111 400,106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u03A8",
    horizAdvX: 687,
    d: "M570,650l0,-196C570,288 489,227 351,222l0,428l-36,0l0,-428C178,227 97,288 97,454l0,196l-39,0l0,-196C58,266 158,190 315,184l0,-184l36,0l0,184C508,189 609,266 609,453l0,197z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Q",
    horizAdvX: 757,
    d: "M695,325C695,518 565,658 372,658C180,658 48,518 48,325C48,132 179,-8 372,-8C415,-8 455,-1 492,12l70,-94l49,0l-82,110C632,82 695,191 695,325M372,32C202,32 87,156 87,325C87,494 202,618 372,618C543,618 655,494 655,325C655,205 598,107 504,61l-64,86l-49,0l75,-101C438,37 406,32 372,32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "R",
    horizAdvX: 596,
    d: "M539,0l-200,275l11,0C450,275 528,355 528,462C528,569 450,650 350,650l-292,0l0,-650l39,0l0,275l194,0l200,-275M97,611l250,0C432,611 488,541 488,462C488,383 432,314 347,314l-250,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0154",
    horizAdvX: 596,
    d: "M285,798l-41,-88l36,0l44,88M539,0l-200,275l11,0C450,275 528,355 528,462C528,569 450,650 350,650l-292,0l0,-650l39,0l0,275l194,0l200,-275M97,611l250,0C432,611 488,541 488,462C488,383 432,314 347,314l-250,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0158",
    horizAdvX: 596,
    d: "M304,798l-41,-68l-42,68l-38,0l55,-88l49,0l55,88M539,0l-200,275l11,0C450,275 528,355 528,462C528,569 450,650 350,650l-292,0l0,-650l39,0l0,275l194,0l200,-275M97,611l250,0C432,611 488,541 488,462C488,383 432,314 347,314l-250,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "S",
    horizAdvX: 595,
    d: "M38,134C69,45 162,-11 295,-11C451,-11 537,54 537,178C537,312 368,342 304,359C232,376 102,394 102,491C102,573 170,621 292,621C394,621 472,580 491,522l35,16C503,610 412,661 295,661C151,661 59,601 59,490C59,362 215,339 286,322C351,305 495,283 495,177C495,79 431,29 297,29C180,29 99,77 72,153z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u015A",
    horizAdvX: 595,
    d: "M316,798l-41,-88l36,0l44,88M38,134C69,45 162,-11 295,-11C451,-11 537,54 537,178C537,312 368,342 304,359C232,376 102,394 102,491C102,573 170,621 292,621C394,621 472,580 491,522l35,16C503,610 412,661 295,661C151,661 59,601 59,490C59,362 215,339 286,322C351,305 495,283 495,177C495,79 431,29 297,29C180,29 99,77 72,153z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0160",
    horizAdvX: 595,
    d: "M335,798l-41,-68l-42,68l-38,0l55,-88l49,0l55,88M38,134C69,45 162,-11 295,-11C451,-11 537,54 537,178C537,312 368,342 304,359C232,376 102,394 102,491C102,573 170,621 292,621C394,621 472,580 491,522l35,16C503,610 412,661 295,661C151,661 59,601 59,490C59,362 215,339 286,322C351,305 495,283 495,177C495,79 431,29 297,29C180,29 99,77 72,153z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u015E",
    horizAdvX: 595,
    d: "M537,178C537,312 368,342 304,359C232,376 102,394 102,491C102,573 170,621 292,621C394,621 472,580 491,522l35,16C503,610 412,661 295,661C151,661 59,601 59,490C59,362 215,339 286,322C351,305 495,283 495,177C495,79 431,29 297,29C180,29 99,77 72,153l-34,-19C68,48 156,-7 281,-11l-19,-32l-1,0l0,-26C267,-65 278,-64 286,-64C309,-64 324,-74 324,-87C324,-101 309,-110 291,-110C276,-110 261,-109 249,-99l0,-30C263,-135 277,-137 291,-137C335,-137 352,-111 352,-87C352,-66 336,-42 294,-39l17,28C457,-7 537,58 537,178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u03A3",
    horizAdvX: 596,
    d: "M518,650l-460,0l0,-33l293,-295l-293,-288l0,-34l460,0l0,38l-398,0l286,284l-287,290l399,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "T",
    horizAdvX: 582,
    d: "M524,650l-486,0l0,-38l223,0l0,-612l40,0l0,612l223,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0166",
    horizAdvX: 599,
    d: "M524,612l0,38l-486,0l0,-38l223,0l0,-268l-157,0l0,-38l157,0l0,-306l40,0l0,306l156,0l0,38l-156,0l0,268z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0164",
    horizAdvX: 582,
    d: "M323,798l-41,-68l-42,68l-38,0l55,-88l49,0l55,88M524,650l-486,0l0,-38l223,0l0,-612l40,0l0,612l223,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "U",
    horizAdvX: 614,
    d: "M497,650l0,-424C497,107 421,31 297,31C173,31 97,107 97,226l0,424l-39,0l0,-427C58,89 147,-8 297,-8C447,-8 537,89 537,223l0,427z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xDA",
    horizAdvX: 614,
    d: "M328,798l-41,-88l36,0l44,88M497,650l0,-424C497,107 421,31 297,31C173,31 97,107 97,226l0,424l-39,0l0,-427C58,89 147,-8 297,-8C447,-8 537,89 537,223l0,427z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xDB",
    horizAdvX: 614,
    d: "M385,710l-55,88l-49,0l-55,-88l38,0l42,68l41,-68M497,650l0,-424C497,107 421,31 297,31C173,31 97,107 97,226l0,424l-39,0l0,-427C58,89 147,-8 297,-8C447,-8 537,89 537,223l0,427z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xDC",
    horizAdvX: 614,
    d: "M219,707C233,707 246,718 246,734C246,749 233,759 219,759C206,759 193,749 193,734C193,718 206,707 219,707M392,707C406,707 419,718 419,734C419,749 406,759 392,759C379,759 366,749 366,734C366,718 379,707 392,707M497,650l0,-424C497,107 421,31 297,31C173,31 97,107 97,226l0,424l-39,0l0,-427C58,89 147,-8 297,-8C447,-8 537,89 537,223l0,427z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD9",
    horizAdvX: 614,
    d: "M285,798l-40,0l45,-88l35,0M497,650l0,-424C497,107 421,31 297,31C173,31 97,107 97,226l0,424l-39,0l0,-427C58,89 147,-8 297,-8C447,-8 537,89 537,223l0,427z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0170",
    horizAdvX: 614,
    d: "M266,798l-41,-88l33,0l47,88M386,798l-41,-88l33,0l48,88M497,650l0,-424C497,107 421,31 297,31C173,31 97,107 97,226l0,424l-39,0l0,-427C58,89 147,-8 297,-8C447,-8 537,89 537,223l0,427z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u016A",
    horizAdvX: 614,
    d: "M227,740l0,-30l158,0l0,30M497,650l0,-424C497,107 421,31 297,31C173,31 97,107 97,226l0,424l-39,0l0,-427C58,89 147,-8 297,-8C447,-8 537,89 537,223l0,427z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0172",
    horizAdvX: 614,
    d: "M497,650l0,-424C497,107 421,31 297,31C173,31 97,107 97,226l0,424l-39,0l0,-427C58,93 141,-1 282,-8C266,-20 250,-40 250,-64C250,-89 271,-119 326,-103l0,29C292,-88 281,-75 281,-60C281,-37 299,-18 312,-8C453,-2 537,93 537,223l0,427z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u016E",
    horizAdvX: 614,
    d: "M306,702C343,702 373,730 373,770C373,812 343,839 306,839C269,839 238,812 238,770C238,730 269,702 306,702M306,727C280,727 265,749 265,770C265,791 280,813 306,813C332,813 346,791 346,770C346,749 332,727 306,727M497,650l0,-424C497,107 421,31 297,31C173,31 97,107 97,226l0,424l-39,0l0,-427C58,89 147,-8 297,-8C447,-8 537,89 537,223l0,427z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0168",
    horizAdvX: 614,
    d: "M180,710l29,0C210,734 223,757 250,757C269,757 283,746 296,732C310,716 328,698 361,698C405,698 429,730 431,774l-29,0C401,749 391,727 361,727C338,727 325,742 314,754C299,771 279,786 250,786C211,786 182,753 180,710M497,650l0,-424C497,107 421,31 297,31C173,31 97,107 97,226l0,424l-39,0l0,-427C58,89 147,-8 297,-8C447,-8 537,89 537,223l0,427z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "V",
    horizAdvX: 634,
    d: "M554,650l-242,-588l-242,588l-42,0l268,-650l32,0l269,650z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "W",
    horizAdvX: 943,
    d: "M862,650l-190,-571l-190,571l-30,0l-191,-573l-191,573l-42,0l217,-650l32,0l189,567l189,-567l33,0l217,650z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u1E82",
    horizAdvX: 943,
    d: "M488,798l-41,-88l36,0l44,88M862,650l-190,-571l-190,571l-30,0l-191,-573l-191,573l-42,0l217,-650l32,0l189,567l189,-567l33,0l217,650z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0174",
    horizAdvX: 943,
    d: "M545,710l-55,88l-49,0l-55,-88l38,0l42,68l41,-68M862,650l-190,-571l-190,571l-30,0l-191,-573l-191,573l-42,0l217,-650l32,0l189,567l189,-567l33,0l217,650z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u1E84",
    horizAdvX: 943,
    d: "M379,707C393,707 406,718 406,734C406,749 393,759 379,759C366,759 353,749 353,734C353,718 366,707 379,707M552,707C566,707 579,718 579,734C579,749 566,759 552,759C539,759 526,749 526,734C526,718 539,707 552,707M862,650l-190,-571l-190,571l-30,0l-191,-573l-191,573l-42,0l217,-650l32,0l189,567l189,-567l33,0l217,650z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u1E80",
    horizAdvX: 943,
    d: "M445,798l-40,0l45,-88l35,0M862,650l-190,-571l-190,571l-30,0l-191,-573l-191,573l-42,0l217,-650l32,0l189,567l189,-567l33,0l217,650z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "X",
    horizAdvX: 583,
    d: "M536,650l-48,0l-206,-291l-206,291l-48,0l230,-325l-230,-325l48,0l206,291l206,-291l48,0l-230,325z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Y",
    horizAdvX: 563,
    d: "M526,650l-47,0l-207,-318l-207,318l-47,0l235,-361l0,-289l39,0l0,291z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xDD",
    horizAdvX: 563,
    d: "M294,798l-41,-88l36,0l44,88M526,650l-47,0l-207,-318l-207,318l-47,0l235,-361l0,-289l39,0l0,291z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0176",
    horizAdvX: 563,
    d: "M351,710l-55,88l-49,0l-55,-88l38,0l42,68l41,-68M526,650l-47,0l-207,-318l-207,318l-47,0l235,-361l0,-289l39,0l0,291z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0178",
    horizAdvX: 563,
    d: "M185,707C199,707 212,718 212,734C212,749 199,759 185,759C172,759 159,749 159,734C159,718 172,707 185,707M358,707C372,707 385,718 385,734C385,749 372,759 358,759C345,759 332,749 332,734C332,718 345,707 358,707M526,650l-47,0l-207,-318l-207,318l-47,0l235,-361l0,-289l39,0l0,291z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u1EF2",
    horizAdvX: 563,
    d: "M251,798l-40,0l45,-88l35,0M526,650l-47,0l-207,-318l-207,318l-47,0l235,-361l0,-289l39,0l0,291z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Z",
    horizAdvX: 537,
    d: "M480,614l0,36l-426,0l0,-38l378,0l-384,-576l0,-36l424,0l0,38l-377,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0179",
    horizAdvX: 537,
    d: "M291,798l-41,-88l36,0l44,88M480,614l0,36l-426,0l0,-38l378,0l-384,-576l0,-36l424,0l0,38l-377,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u017D",
    horizAdvX: 537,
    d: "M310,798l-41,-68l-42,68l-38,0l55,-88l49,0l55,88M480,614l0,36l-426,0l0,-38l378,0l-384,-576l0,-36l424,0l0,38l-377,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u017B",
    horizAdvX: 537,
    d: "M269,707C283,707 296,718 296,734C296,749 283,759 269,759C256,759 243,749 243,734C243,718 256,707 269,707M480,614l0,36l-426,0l0,-38l378,0l-384,-576l0,-36l424,0l0,38l-377,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "a",
    horizAdvX: 587,
    d: "M472,460l0,-111C437,421 367,467 275,467C140,467 46,367 46,230C46,93 140,-8 275,-8C367,-8 437,39 472,111l0,-111l38,0l0,460M278,28C161,28 83,113 83,230C83,347 161,431 278,431C396,431 472,347 472,230C472,113 396,28 278,28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE1",
    horizAdvX: 587,
    d: "M314,615l-41,-88l36,0l44,88M472,460l0,-111C437,421 367,467 275,467C140,467 46,367 46,230C46,93 140,-8 275,-8C367,-8 437,39 472,111l0,-111l38,0l0,460M278,28C161,28 83,113 83,230C83,347 161,431 278,431C396,431 472,347 472,230C472,113 396,28 278,28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0103",
    horizAdvX: 587,
    d: "M368,605l-29,0l0,-3C339,576 321,554 292,554C262,554 244,576 244,602l0,3l-29,0l0,-3C215,557 250,526 292,526C334,526 368,557 368,602M472,460l0,-111C437,421 367,467 275,467C140,467 46,367 46,230C46,93 140,-8 275,-8C367,-8 437,39 472,111l0,-111l38,0l0,460M278,28C161,28 83,113 83,230C83,347 161,431 278,431C396,431 472,347 472,230C472,113 396,28 278,28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE2",
    horizAdvX: 587,
    d: "M371,527l-55,88l-49,0l-55,-88l38,0l42,68l41,-68M472,460l0,-111C437,421 367,467 275,467C140,467 46,367 46,230C46,93 140,-8 275,-8C367,-8 437,39 472,111l0,-111l38,0l0,460M278,28C161,28 83,113 83,230C83,347 161,431 278,431C396,431 472,347 472,230C472,113 396,28 278,28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB4",
    horizAdvX: 120,
    d: "M61,650l-41,-88l36,0l44,88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0301",
    horizAdvX: 0,
    d: "M-59,650l-41,-88l36,0l44,88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE4",
    horizAdvX: 587,
    d: "M205,524C219,524 232,535 232,551C232,566 219,576 205,576C192,576 179,566 179,551C179,535 192,524 205,524M378,524C392,524 405,535 405,551C405,566 392,576 378,576C365,576 352,566 352,551C352,535 365,524 378,524M472,460l0,-111C437,421 367,467 275,467C140,467 46,367 46,230C46,93 140,-8 275,-8C367,-8 437,39 472,111l0,-111l38,0l0,460M278,28C161,28 83,113 83,230C83,347 161,431 278,431C396,431 472,347 472,230C472,113 396,28 278,28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE6",
    horizAdvX: 933,
    d: "M647,467C548,467 471,415 439,334C426,417 366,467 251,467C141,467 82,423 59,359l33,-10C112,399 160,435 250,435C359,435 407,388 407,243C235,243 46,258 46,113C46,20 117,-8 235,-8C374,-8 423,63 439,136C467,54 545,-8 653,-8C737,-8 805,30 845,91l-28,18C782,56 724,26 654,26C543,26 473,103 467,214l399,0l0,16C866,367 774,467 647,467M649,434C751,434 826,357 830,244l-364,0C471,355 534,434 649,434M233,23C136,23 83,42 83,114C83,229 243,214 407,214C407,82 353,23 233,23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE0",
    horizAdvX: 587,
    d: "M271,615l-40,0l45,-88l35,0M472,460l0,-111C437,421 367,467 275,467C140,467 46,367 46,230C46,93 140,-8 275,-8C367,-8 437,39 472,111l0,-111l38,0l0,460M278,28C161,28 83,113 83,230C83,347 161,431 278,431C396,431 472,347 472,230C472,113 396,28 278,28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0101",
    horizAdvX: 587,
    d: "M213,556l0,-30l158,0l0,30M472,460l0,-111C437,421 367,467 275,467C140,467 46,367 46,230C46,93 140,-8 275,-8C367,-8 437,39 472,111l0,-111l38,0l0,460M278,28C161,28 83,113 83,230C83,347 161,431 278,431C396,431 472,347 472,230C472,113 396,28 278,28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "&",
    horizAdvX: 616,
    d: "M538,-1C520,21 494,55 463,94C491,136 507,191 507,255l0,17l-35,0l0,-17C472,202 460,158 441,123C378,204 303,300 254,364C308,396 395,446 395,536C395,604 339,661 260,661C179,661 122,604 122,536C122,505 134,467 178,411C182,405 192,392 206,374C98,303 58,247 58,169C58,63 137,-11 269,-11C337,-11 399,16 442,66C463,39 481,16 495,-1M157,535C157,587 202,628 260,628C317,628 360,588 360,535C360,464 286,423 233,391C218,411 207,425 203,431C173,472 157,499 157,535M269,24C159,24 96,83 96,169C96,230 122,277 227,347l194,-253C383,48 329,24 269,24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0105",
    horizAdvX: 587,
    d: "M468,-56C468,-30 491,-10 503,0l7,0l0,460l-38,0l0,-111C437,421 367,467 275,467C140,467 46,367 46,230C46,93 140,-8 275,-8C367,-8 437,39 472,111l0,-111l2,0C456,-12 437,-33 437,-60C437,-85 458,-115 513,-99l0,29C479,-84 468,-71 468,-56M278,28C161,28 83,113 83,230C83,347 161,431 278,431C396,431 472,347 472,230C472,113 396,28 278,28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2248",
    horizAdvX: 603,
    d: "M491,466C491,404 452,367 397,367C356,367 327,395 300,420C276,442 241,480 184,480C107,480 58,425 58,347l34,0C92,405 128,445 185,445C227,445 255,416 281,392C306,369 340,333 397,333C475,333 525,388 525,466M491,297C491,235 452,198 397,198C356,198 327,226 300,251C276,273 241,311 184,311C107,311 58,256 58,178l34,0C92,236 128,276 185,276C227,276 255,248 281,224C306,201 340,164 397,164C475,164 525,220 525,297z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE5",
    horizAdvX: 587,
    d: "M292,519C329,519 359,547 359,587C359,629 329,656 292,656C255,656 224,629 224,587C224,547 255,519 292,519M292,544C266,544 251,566 251,587C251,608 266,630 292,630C318,630 332,608 332,587C332,566 318,544 292,544M472,460l0,-111C437,421 367,467 275,467C140,467 46,367 46,230C46,93 140,-8 275,-8C367,-8 437,39 472,111l0,-111l38,0l0,460M278,28C161,28 83,113 83,230C83,347 161,431 278,431C396,431 472,347 472,230C472,113 396,28 278,28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2194",
    horizAdvX: 900,
    d: "M608,562l-25,-25l197,-197l-662,0l197,197l-26,25l-240,-240l240,-240l26,25l-195,195l658,0l-195,-195l25,-25l241,240z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2193",
    horizAdvX: 615,
    d: "M513,275l-197,-196l0,555l-38,0l0,-553l-195,195l-25,-26l240,-240l240,239z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2190",
    horizAdvX: 760,
    d: "M682,340l-555,0l197,197l-26,25l-240,-240l240,-240l26,25l-195,195l553,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2192",
    horizAdvX: 760,
    d: "M442,562l-26,-25l197,-197l-555,0l0,-38l553,0l-195,-195l26,-25l240,240z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2191",
    horizAdvX: 615,
    d: "M538,395l-240,239l-240,-240l25,-26l195,195l0,-553l38,0l0,555l197,-196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2195",
    horizAdvX: 610,
    d: "M532,220l-25,26l-194,-194l0,546l194,-194l25,26l-237,237l-237,-237l25,-26l192,192l0,-542l-192,191l-25,-26l237,-237z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "^",
    horizAdvX: 348,
    d: "M270,413l-87,237l-38,0l-87,-237l35,0l71,193l71,-193z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "~",
    horizAdvX: 603,
    d: "M491,381C491,319 452,283 397,283C356,283 327,310 300,335C276,357 241,396 184,396C107,396 58,341 58,263l34,0C92,320 128,361 185,361C227,361 255,332 281,308C306,285 340,248 397,248C475,248 525,304 525,381z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "*",
    horizAdvX: 391,
    d: "M336,569l-16,24l-110,-75l0,132l-30,0l0,-131l-109,75l-16,-24l115,-79l-115,-78l16,-25l109,74l0,-131l30,0l0,132l109,-75l16,24l-114,79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "@",
    horizAdvX: 796,
    d: "M389,665C196,665 58,520 58,325C58,131 195,-16 389,-16C447,-16 502,-3 546,19l-16,29C488,26 442,16 389,16C216,16 89,147 89,325C89,503 216,633 389,633C562,633 687,520 687,341C687,251 667,182 604,182C568,182 540,211 540,257l0,221l-31,0l0,-64C484,456 440,483 382,483C294,483 227,417 227,322C227,226 294,160 382,160C441,160 486,187 511,232C520,180 560,154 604,154C690,154 719,241 719,341C719,534 582,665 389,665M384,191C307,191 259,253 259,322C259,390 307,451 384,451C461,451 509,390 509,322C509,253 461,191 384,191z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE3",
    horizAdvX: 587,
    d: "M166,527l29,0C196,551 209,574 236,574C255,574 269,563 282,549C296,533 314,515 347,515C391,515 415,547 417,591l-29,0C387,566 377,544 347,544C324,544 311,559 300,571C285,588 265,603 236,603C197,603 168,570 166,527M472,460l0,-111C437,421 367,467 275,467C140,467 46,367 46,230C46,93 140,-8 275,-8C367,-8 437,39 472,111l0,-111l38,0l0,460M278,28C161,28 83,113 83,230C83,347 161,431 278,431C396,431 472,347 472,230C472,113 396,28 278,28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "b",
    horizAdvX: 587,
    d: "M292,467C200,467 130,421 95,349l0,301l-37,0l0,-650l37,0l0,111C130,39 200,-8 292,-8C427,-8 521,93 521,230C521,367 427,467 292,467M289,28C172,28 95,113 95,230C95,347 172,431 289,431C406,431 484,347 484,230C484,113 406,28 289,28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\\\\\\\",
    horizAdvX: 275,
    d: "M255,-48l-212,739l-40,0l212,-739z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "|",
    horizAdvX: 173,
    d: "M96,-48l0,740l-38,0l0,-740z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "{",
    horizAdvX: 307,
    d: "M147,386l0,229C147,644 158,658 180,658l49,0l0,34l-58,0C142,692 109,676 109,619l0,-233C109,355 92,338 73,338l-15,0l0,-32l15,0C92,306 109,289 109,258l0,-233C109,-31 142,-48 171,-48l58,0l0,34l-49,0C158,-14 147,0 147,29l0,229C147,289 134,310 115,322C134,334 147,355 147,386z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "}",
    horizAdvX: 307,
    d: "M214,338C195,338 178,355 178,386l0,233C178,676 144,692 116,692l-58,0l0,-34l49,0C129,658 140,644 140,615l0,-229C140,355 153,334 172,322C153,310 140,289 140,258l0,-229C140,0 129,-14 107,-14l-49,0l0,-34l58,0C144,-48 178,-31 178,25l0,233C178,289 195,306 214,306l15,0l0,32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "[",
    horizAdvX: 256,
    d: "M178,658l0,34l-120,0l0,-740l120,0l0,34l-82,0l0,672z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "]",
    horizAdvX: 256,
    d: "M58,658l82,0l0,-672l-82,0l0,-34l120,0l0,740l-120,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u02D8",
    horizAdvX: 190,
    d: "M170,650l-29,0l0,-3C141,620 124,599 96,599C66,599 49,620 49,647l0,3l-29,0l0,-3C20,601 55,571 96,571C136,571 170,601 170,647z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xA6",
    horizAdvX: 173,
    d: "M96,407l0,285l-38,0l0,-285M96,-48l0,285l-38,0l0,-285z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2022",
    horizAdvX: 169,
    d: "M84,278C111,278 131,299 131,325C131,351 111,372 84,372C58,372 38,351 38,325C38,299 58,278 84,278z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "c",
    horizAdvX: 521,
    d: "M437,354l28,21C425,432 359,467 278,467C141,467 46,367 46,230C46,93 141,-8 278,-8C359,-8 425,27 465,85l-28,20C403,59 350,28 279,28C161,28 83,113 83,230C83,347 161,431 279,431C350,431 403,401 437,354z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0107",
    horizAdvX: 521,
    d: "M300,615l-41,-88l36,0l44,88M437,354l28,21C425,432 359,467 278,467C141,467 46,367 46,230C46,93 141,-8 278,-8C359,-8 425,27 465,85l-28,20C403,59 350,28 279,28C161,28 83,113 83,230C83,347 161,431 279,431C350,431 403,401 437,354z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u02C7",
    horizAdvX: 199,
    d: "M141,650l-41,-68l-42,68l-38,0l55,-88l49,0l55,88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u010D",
    horizAdvX: 521,
    d: "M319,615l-41,-68l-42,68l-38,0l55,-88l49,0l55,88M437,354l28,21C425,432 359,467 278,467C141,467 46,367 46,230C46,93 141,-8 278,-8C359,-8 425,27 465,85l-28,20C403,59 350,28 279,28C161,28 83,113 83,230C83,347 161,431 279,431C350,431 403,401 437,354z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE7",
    horizAdvX: 521,
    d: "M279,28C161,28 83,113 83,230C83,347 161,431 279,431C350,431 403,401 437,354l28,21C425,432 359,467 278,467C141,467 46,367 46,230C46,99 133,1 260,-7l-18,-30l-1,0l0,-26C247,-59 258,-58 266,-58C289,-58 304,-68 304,-81C304,-95 289,-104 271,-104C256,-104 241,-103 229,-93l0,-30C243,-129 257,-131 271,-131C315,-131 332,-105 332,-81C332,-60 316,-36 274,-33l15,25C365,-5 427,30 465,85l-28,20C403,59 350,28 279,28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u010B",
    horizAdvX: 521,
    d: "M278,524C292,524 305,535 305,551C305,566 292,576 278,576C265,576 252,566 252,551C252,535 265,524 278,524M437,354l28,21C425,432 359,467 278,467C141,467 46,367 46,230C46,93 141,-8 278,-8C359,-8 425,27 465,85l-28,20C403,59 350,28 279,28C161,28 83,113 83,230C83,347 161,431 279,431C350,431 403,401 437,354z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB8",
    horizAdvX: 149,
    d: "M70,-34l19,34l-28,0l-24,-38l-1,0l1,-26C43,-60 54,-59 61,-59C85,-59 100,-69 100,-82C100,-96 84,-105 67,-105C51,-105 37,-104 24,-94l0,-30C38,-130 52,-132 67,-132C111,-132 127,-106 127,-82C127,-61 111,-37 70,-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xA2",
    horizAdvX: 673,
    d: "M353,65C187,65 97,185 97,330C97,475 187,594 353,594C452,594 513,551 562,481l34,21C540,583 469,632 355,633l0,64l-38,0l0,-66C147,615 58,483 58,330C58,177 147,44 317,28l0,-76l38,0l0,74C469,27 540,76 596,157l-34,20C513,107 452,65 353,65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u02C6",
    horizAdvX: 199,
    d: "M179,562l-55,88l-49,0l-55,-88l38,0l42,68l41,-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ":",
    horizAdvX: 133,
    d: "M65,287C81,287 93,300 93,315C93,331 81,343 65,343C50,343 38,331 38,315C38,300 50,287 65,287M65,-1C81,-1 93,11 93,27C93,42 81,54 65,54C50,54 38,42 38,27C38,11 50,-1 65,-1z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ",",
    horizAdvX: 151,
    d: "M62,45l-24,-117l33,0l42,117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xA9",
    horizAdvX: 783,
    d: "M382,-8C575,-8 705,132 705,325C705,518 575,658 382,658C189,658 58,518 58,325C58,132 189,-8 382,-8M382,21C202,21 87,154 87,325C87,496 201,629 382,629C563,629 676,496 676,325C676,154 563,21 382,21M506,417l25,17C501,477 452,503 391,503C289,503 219,429 219,326C219,223 289,148 391,148C452,148 501,174 531,218l-25,16C486,205 444,177 391,177C311,177 249,237 249,326C249,414 311,474 391,474C444,474 486,450 506,417z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xA4",
    horizAdvX: 564,
    d: "M456,323C456,371 441,412 417,444l69,69l-24,23l-68,-68C362,495 320,511 273,511C225,511 183,495 151,467l-69,69l-24,-24l69,-69C103,411 89,370 89,323C89,275 104,234 128,202l-70,-70l24,-23l69,69C183,150 226,134 273,134C319,134 361,150 393,177l69,-69l24,24l-70,70C441,233 456,275 456,323M273,168C190,168 123,232 123,323C123,415 190,477 273,477C357,477 422,415 422,323C422,232 357,168 273,168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "d",
    horizAdvX: 587,
    d: "M472,650l0,-301C437,421 367,467 275,467C140,467 46,367 46,230C46,93 140,-8 275,-8C367,-8 437,39 472,111l0,-111l38,0l0,650M278,28C161,28 83,113 83,230C83,347 161,431 278,431C396,431 472,347 472,230C472,113 396,28 278,28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2020",
    horizAdvX: 414,
    d: "M336,467l-120,0l0,183l-38,0l0,-183l-120,0l0,-34l120,0l0,-433l38,0l0,433l120,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2021",
    horizAdvX: 414,
    d: "M336,422l0,34l-120,0l0,194l-38,0l0,-194l-120,0l0,-34l120,0l0,-187l-120,0l0,-34l120,0l0,-201l38,0l0,201l120,0l0,34l-120,0l0,187z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u010F",
    horizAdvX: 587,
    d: "M532,798l-41,-68l-42,68l-38,0l55,-88l49,0l55,88M472,650l0,-301C437,421 367,467 275,467C140,467 46,367 46,230C46,93 140,-8 275,-8C367,-8 437,39 472,111l0,-111l38,0l0,650M278,28C161,28 83,113 83,230C83,347 161,431 278,431C396,431 472,347 472,230C472,113 396,28 278,28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB0",
    horizAdvX: 339,
    d: "M170,421C233,421 283,468 283,536C283,605 233,651 170,651C105,651 56,605 56,536C56,468 105,421 170,421M170,448C123,448 85,485 85,536C85,586 123,623 170,623C216,623 254,586 254,536C254,485 216,448 170,448z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xA8",
    horizAdvX: 266,
    d: "M46,604C60,604 73,615 73,631C73,646 60,656 46,656C33,656 20,646 20,631C20,615 33,604 46,604M219,604C233,604 246,615 246,631C246,646 233,656 219,656C206,656 193,646 193,631C193,615 206,604 219,604z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF7",
    horizAdvX: 503,
    d: "M242,443C258,443 270,456 270,471C270,487 258,499 242,499C226,499 214,487 214,471C214,456 226,443 242,443M58,339l0,-34l367,0l0,34M242,145C258,145 270,157 270,173C270,189 258,201 242,201C226,201 214,189 214,173C214,157 226,145 242,145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "$",
    horizAdvX: 622,
    d: "M321,354C250,374 131,389 131,485C131,549 199,596 312,596C410,596 489,555 507,497l36,16C519,581 436,629 331,634l0,58l-39,0l0,-58C169,628 88,569 88,484C88,358 234,335 305,318C369,303 500,280 500,175C500,94 435,48 313,48C199,48 119,94 92,169l-34,-18C87,66 173,15 292,9l0,-57l39,0l0,57C465,14 543,75 543,176C543,309 384,337 321,354z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u02D9",
    horizAdvX: 93,
    d: "M46,604C60,604 73,615 73,631C73,646 60,656 46,656C33,656 20,646 20,631C20,615 33,604 46,604z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0323",
    horizAdvX: 0,
    d: "M-47,-52C-33,-52 -20,-41 -20,-26C-20,-11 -33,0 -47,0C-60,0 -73,-11 -73,-26C-73,-41 -60,-52 -47,-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0131",
    horizAdvX: 190,
    d: "M104,0l0,460l-38,0l0,-460z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "e",
    horizAdvX: 558,
    d: "M272,467C135,467 46,367 46,230C46,93 140,-8 278,-8C362,-8 430,29 470,90l-28,19C409,59 352,26 278,26C166,26 90,103 83,215l408,0l0,15C491,367 401,467 272,467M272,434C377,434 450,355 456,245l-373,0C89,357 159,434 272,434z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE9",
    horizAdvX: 558,
    d: "M294,615l-41,-88l36,0l44,88M272,467C135,467 46,367 46,230C46,93 140,-8 278,-8C362,-8 430,29 470,90l-28,19C409,59 352,26 278,26C166,26 90,103 83,215l408,0l0,15C491,367 401,467 272,467M272,434C377,434 450,355 456,245l-373,0C89,357 159,434 272,434z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u011B",
    horizAdvX: 558,
    d: "M313,615l-41,-68l-42,68l-38,0l55,-88l49,0l55,88M272,467C135,467 46,367 46,230C46,93 140,-8 278,-8C362,-8 430,29 470,90l-28,19C409,59 352,26 278,26C166,26 90,103 83,215l408,0l0,15C491,367 401,467 272,467M272,434C377,434 450,355 456,245l-373,0C89,357 159,434 272,434z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xEA",
    horizAdvX: 558,
    d: "M351,527l-55,88l-49,0l-55,-88l38,0l42,68l41,-68M272,467C135,467 46,367 46,230C46,93 140,-8 278,-8C362,-8 430,29 470,90l-28,19C409,59 352,26 278,26C166,26 90,103 83,215l408,0l0,15C491,367 401,467 272,467M272,434C377,434 450,355 456,245l-373,0C89,357 159,434 272,434z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xEB",
    horizAdvX: 558,
    d: "M185,524C199,524 212,535 212,551C212,566 199,576 185,576C172,576 159,566 159,551C159,535 172,524 185,524M358,524C372,524 385,535 385,551C385,566 372,576 358,576C345,576 332,566 332,551C332,535 345,524 358,524M272,467C135,467 46,367 46,230C46,93 140,-8 278,-8C362,-8 430,29 470,90l-28,19C409,59 352,26 278,26C166,26 90,103 83,215l408,0l0,15C491,367 401,467 272,467M272,434C377,434 450,355 456,245l-373,0C89,357 159,434 272,434z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0117",
    horizAdvX: 558,
    d: "M272,524C286,524 299,535 299,551C299,566 286,576 272,576C259,576 246,566 246,551C246,535 259,524 272,524M272,467C135,467 46,367 46,230C46,93 140,-8 278,-8C362,-8 430,29 470,90l-28,19C409,59 352,26 278,26C166,26 90,103 83,215l408,0l0,15C491,367 401,467 272,467M272,434C377,434 450,355 456,245l-373,0C89,357 159,434 272,434z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE8",
    horizAdvX: 558,
    d: "M251,615l-40,0l45,-88l35,0M272,467C135,467 46,367 46,230C46,93 140,-8 278,-8C362,-8 430,29 470,90l-28,19C409,59 352,26 278,26C166,26 90,103 83,215l408,0l0,15C491,367 401,467 272,467M272,434C377,434 450,355 456,245l-373,0C89,357 159,434 272,434z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 8,
    horizAdvX: 548,
    d: "M364,337C441,363 476,423 476,490C476,574 413,658 267,658C122,658 58,574 58,490C58,423 93,363 171,337C89,309 48,245 48,174C48,68 122,-8 267,-8C413,-8 486,68 486,174C486,245 445,309 364,337M96,489C96,556 146,623 267,623C389,623 438,556 438,489C438,414 389,355 267,355C146,355 96,414 96,489M267,28C146,28 87,89 87,175C87,253 146,320 267,320C389,320 447,253 447,175C447,88 389,28 267,28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2026",
    horizAdvX: 454,
    d: "M65,-1C81,-1 93,11 93,27C93,42 81,54 65,54C50,54 38,42 38,27C38,11 50,-1 65,-1M230,-1C246,-1 258,11 258,27C258,42 246,54 230,54C215,54 203,42 203,27C203,11 215,-1 230,-1M389,-1C405,-1 417,11 417,27C417,42 405,54 389,54C374,54 362,42 362,27C362,11 374,-1 389,-1z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0113",
    horizAdvX: 558,
    d: "M193,556l0,-30l158,0l0,30M272,467C135,467 46,367 46,230C46,93 140,-8 278,-8C362,-8 430,29 470,90l-28,19C409,59 352,26 278,26C166,26 90,103 83,215l408,0l0,15C491,367 401,467 272,467M272,434C377,434 450,355 456,245l-373,0C89,357 159,434 272,434z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2014",
    horizAdvX: 663,
    d: "M58,324l0,-38l527,0l0,38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2205",
    horizAdvX: 595,
    d: "M425,517l37,60l-32,0l-28,-46C369,548 331,558 289,558C151,558 58,458 58,321C58,237 93,167 151,126l-37,-61l32,0l29,46C207,94 246,84 289,84C426,84 518,184 518,321C518,405 483,475 425,517M93,321C93,436 172,524 289,524C324,524 356,516 383,501l-213,-345C122,192 93,252 93,321M289,118C253,118 221,126 193,141l213,345C454,450 482,390 482,321C482,206 405,118 289,118z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2013",
    horizAdvX: 493,
    d: "M58,325l0,-38l358,0l0,38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0119",
    horizAdvX: 558,
    d: "M491,230C491,367 401,467 272,467C135,467 46,367 46,230C46,97 135,-3 267,-8C249,-19 228,-41 228,-69C228,-94 249,-124 304,-108l0,29C270,-93 259,-80 259,-65C259,-37 284,-16 296,-7C372,-2 433,34 470,90l-28,19C409,59 352,26 278,26C166,26 90,103 83,215l408,0M83,245C89,357 159,434 272,434C377,434 450,355 456,245z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "=",
    horizAdvX: 502,
    d: "M58,435l0,-34l366,0l0,34M58,243l0,-35l366,0l0,35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "!",
    horizAdvX: 171,
    d: "M86,650l-41,0l3,-514l35,0M65,55C50,55 38,42 38,27C38,11 50,-1 65,-1C81,-1 93,11 93,27C93,42 81,55 65,55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xA1",
    horizAdvX: 101,
    d: "M48,595C63,595 76,608 76,623C76,639 63,651 48,651C33,651 20,639 20,623C20,608 33,595 48,595M69,0l-3,518l-36,0l-3,-518z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "f",
    horizAdvX: 326,
    d: "M213,617l65,0l0,33l-71,0C137,650 95,608 95,539l0,-79l-67,0l0,-32l67,0l0,-428l38,0l0,428l134,0l0,32l-134,0l0,77C133,587 164,617 213,617z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 5,
    horizAdvX: 532,
    d: "M242,413C208,413 162,406 126,394l31,218l286,0l0,38l-319,0l-41,-275l17,-30C132,366 195,378 242,378C357,378 430,305 430,206C430,105 364,31 243,30C173,30 106,59 68,110l-30,-25C79,29 159,-8 244,-8C382,-8 470,76 470,205C470,321 389,413 242,413z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u215D",
    horizAdvX: 610,
    d: "M123,535C105,535 82,532 64,526l16,110l144,0l0,19l-161,0l-21,-139l9,-15C67,511 99,518 123,518C181,518 218,481 218,430C218,379 184,342 123,341C88,341 54,356 34,382l-15,-13C40,341 81,322 124,322C194,322 238,365 238,430C238,489 197,535 123,535M118,0l401,650l-22,0l-401,-650M531,166C569,179 587,209 587,242C587,284 555,326 483,326C411,326 379,284 379,242C379,209 396,179 435,166C394,153 374,121 374,85C374,33 411,-5 483,-5C555,-5 592,33 592,85C592,121 571,153 531,166M398,242C398,275 423,309 483,309C543,309 568,275 568,242C568,205 543,175 483,175C423,175 398,205 398,242M483,13C423,13 393,43 393,86C393,125 423,158 483,158C543,158 572,125 572,86C572,43 543,13 483,13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 4,
    horizAdvX: 555,
    d: "M507,185l-77,0l0,465l-40,0l-352,-467l0,-32l352,0l0,-151l40,0l0,151l77,0M82,185l308,408l0,-408z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2044",
    horizAdvX: 463,
    d: "M42,0l401,650l-22,0l-401,-650z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "g",
    horizAdvX: 587,
    d: "M472,460l0,-111C437,421 367,467 275,467C140,467 46,367 46,230C46,93 140,-8 275,-8C367,-8 437,39 472,111l0,-76C472,-83 384,-152 271,-152C205,-152 149,-128 111,-84l-27,-22C126,-156 193,-186 271,-186C412,-186 510,-97 510,35l0,425M278,28C161,28 83,113 83,230C83,347 161,431 278,431C395,431 472,347 472,230C472,113 395,28 278,28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u011F",
    horizAdvX: 587,
    d: "M356,605l-29,0l0,-3C327,576 309,554 280,554C250,554 232,576 232,602l0,3l-29,0l0,-3C203,557 238,526 280,526C322,526 356,557 356,602M472,460l0,-111C437,421 367,467 275,467C140,467 46,367 46,230C46,93 140,-8 275,-8C367,-8 437,39 472,111l0,-76C472,-83 384,-152 271,-152C205,-152 149,-128 111,-84l-27,-22C126,-156 193,-186 271,-186C412,-186 510,-97 510,35l0,425M278,28C161,28 83,113 83,230C83,347 161,431 278,431C395,431 472,347 472,230C472,113 395,28 278,28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u01E7",
    horizAdvX: 587,
    d: "M321,615l-41,-68l-42,68l-38,0l55,-88l49,0l55,88M472,460l0,-111C437,421 367,467 275,467C140,467 46,367 46,230C46,93 140,-8 275,-8C367,-8 437,39 472,111l0,-76C472,-83 384,-152 271,-152C205,-152 149,-128 111,-84l-27,-22C126,-156 193,-186 271,-186C412,-186 510,-97 510,35l0,425M278,28C161,28 83,113 83,230C83,347 161,431 278,431C395,431 472,347 472,230C472,113 395,28 278,28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0121",
    horizAdvX: 587,
    d: "M280,524C294,524 307,535 307,551C307,566 294,576 280,576C267,576 254,566 254,551C254,535 267,524 280,524M472,460l0,-111C437,421 367,467 275,467C140,467 46,367 46,230C46,93 140,-8 275,-8C367,-8 437,39 472,111l0,-76C472,-83 384,-152 271,-152C205,-152 149,-128 111,-84l-27,-22C126,-156 193,-186 271,-186C412,-186 510,-97 510,35l0,425M278,28C161,28 83,113 83,230C83,347 161,431 278,431C395,431 472,347 472,230C472,113 395,28 278,28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xDF",
    horizAdvX: 513,
    d: "M351,341C405,366 441,417 441,486C441,597 358,661 255,661C136,661 58,594 58,488l0,-488l39,0l0,487C97,569 155,625 255,625C340,625 403,572 403,484C403,404 345,352 257,352l-111,0l0,-36l132,0C364,316 426,258 426,177C426,95 364,37 278,37l-132,0l0,-37l137,0C391,0 465,75 465,177C465,255 420,318 351,341z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "`",
    horizAdvX: 120,
    d: "M60,650l-40,0l45,-88l35,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0300",
    horizAdvX: 0,
    d: "M-60,650l-40,0l45,-88l35,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ">",
    horizAdvX: 465,
    d: "M58,462l0,-35l285,-105l-285,-106l0,-35l330,122l0,37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2265",
    horizAdvX: 468,
    d: "M388,340l0,38l-330,98l0,-34l281,-83l-281,-84l0,-33M58,198l0,-31l333,0l0,31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xAB",
    horizAdvX: 505,
    d: "M244,135l-171,186l171,186l-49,0l-172,-186l172,-186M463,135l-171,186l171,186l-50,0l-172,-186l172,-186z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xBB",
    horizAdvX: 534,
    d: "M38,135l48,0l172,186l-172,186l-48,0l171,-186M256,135l48,0l172,186l-172,186l-48,0l171,-186z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2039",
    horizAdvX: 316,
    d: "M259,135l-171,186l171,186l-49,0l-172,-186l172,-186z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u203A",
    horizAdvX: 316,
    d: "M38,135l49,0l172,186l-172,186l-49,0l171,-186z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "h",
    horizAdvX: 519,
    d: "M256,467C190,467 128,440 95,383l0,267l-37,0l0,-650l37,0l0,281C95,374 159,433 249,433C339,433 404,374 404,281l0,-281l37,0l0,284C441,407 354,467 256,467z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u02DD",
    horizAdvX: 241,
    d: "M61,650l-41,-88l33,0l47,88M181,650l-41,-88l33,0l48,88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "-",
    horizAdvX: 408,
    d: "M58,324l0,-38l273,0l0,38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "i",
    horizAdvX: 191,
    d: "M86,578C100,578 114,590 114,606C114,623 100,634 86,634C71,634 58,623 58,606C58,590 71,578 86,578M104,0l1,460l-38,0l0,-460z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xED",
    horizAdvX: 190,
    d: "M107,615l-41,-88l36,0l44,88M104,0l0,460l-38,0l0,-460z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xEE",
    horizAdvX: 190,
    d: "M164,527l-55,88l-49,0l-55,-88l38,0l42,68l41,-68M104,0l0,460l-38,0l0,-460z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xEF",
    horizAdvX: 190,
    d: "M-2,524C12,524 25,535 25,551C25,566 12,576 -2,576C-15,576 -28,566 -28,551C-28,535 -15,524 -2,524M171,524C185,524 198,535 198,551C198,566 185,576 171,576C158,576 145,566 145,551C145,535 158,524 171,524M104,0l0,460l-38,0l0,-460z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xEC",
    horizAdvX: 190,
    d: "M64,615l-40,0l45,-88l35,0M104,0l0,460l-38,0l0,-460z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u012B",
    horizAdvX: 190,
    d: "M6,556l0,-30l158,0l0,30M104,0l0,460l-38,0l0,-460z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u221E",
    horizAdvX: 853,
    d: "M206,175C288,175 330,215 420,303C512,216 545,175 627,175C710,175 776,242 776,323C776,403 710,470 627,470C569,470 534,459 420,347C313,445 284,470 206,470C124,470 58,403 58,323C58,242 124,175 206,175M206,208C141,208 89,255 89,323C89,389 141,437 206,437C259,437 283,430 395,324C322,250 272,208 206,208M627,208C561,208 527,245 445,325C555,430 570,437 627,437C692,437 744,389 744,323C744,255 692,208 627,208z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u222B",
    horizAdvX: 512,
    d: "M372,692C306,692 264,651 256,578l-57,-509C193,17 166,-16 114,-16l-56,0l0,-32l62,0C187,-48 228,-7 236,65l57,511C299,628 326,660 378,660l57,0l0,32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u012F",
    horizAdvX: 190,
    d: "M85,524C99,524 112,535 112,551C112,566 99,576 85,576C72,576 59,566 59,551C59,535 72,524 85,524M61,-58C61,-30 87,-9 99,0l5,0l0,460l-38,0l0,-460l5,0C52,-11 30,-34 30,-62C30,-87 51,-117 106,-101l0,29C72,-86 61,-73 61,-58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0129",
    horizAdvX: 190,
    d: "M-41,527l29,0C-11,551 2,574 29,574C48,574 62,563 75,549C89,533 107,515 140,515C184,515 208,547 210,591l-29,0C180,566 170,544 140,544C117,544 104,559 93,571C78,588 58,603 29,603C-10,603 -39,570 -41,527M104,0l0,460l-38,0l0,-460z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "j",
    horizAdvX: 204,
    d: "M98,578C113,578 126,590 126,606C126,623 113,634 98,634C83,634 70,623 70,606C70,590 84,578 98,578M6,-184C76,-184 117,-141 117,-76l0,536l-37,0l0,-531C80,-124 47,-151 -2,-151l-27,0l0,-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "k",
    horizAdvX: 439,
    d: "M402,0l-269,242l248,218l-50,0l-236,-207l0,397l-37,0l0,-650l37,0l0,231l257,-231z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "l",
    horizAdvX: 173,
    d: "M95,0l0,650l-37,0l0,-650z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u013A",
    horizAdvX: 173,
    d: "M98,798l-41,-88l36,0l44,88M95,0l0,650l-37,0l0,-650z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u013E",
    horizAdvX: 173,
    d: "M117,798l-41,-68l-42,68l-38,0l55,-88l49,0l55,88M95,0l0,650l-37,0l0,-650z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "<",
    horizAdvX: 465,
    d: "M388,462l-330,-122l0,-37l330,-122l0,35l-285,106l285,105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2264",
    horizAdvX: 468,
    d: "M391,476l-330,-98l0,-38l330,-98l0,33l-281,84l281,83M58,167l333,0l0,31l-333,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xAC",
    horizAdvX: 507,
    d: "M58,348l0,-38l333,0l0,-125l38,0l0,163z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u25CA",
    horizAdvX: 592,
    d: "M308,650l-43,0l-207,-328l203,-322l51,0l203,322M287,25l-188,297l188,297l187,-297z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0142",
    horizAdvX: 173,
    d: "M161,391l-66,-24l0,283l-37,0l0,-296l-56,-20l0,-35l56,20l0,-319l37,0l0,332l66,24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "m",
    horizAdvX: 810,
    d: "M561,467C494,467 429,438 400,366C373,438 309,467 242,467C183,467 126,443 95,389l0,71l-37,0l0,-460l37,0l0,282C95,382 155,432 236,432C316,432 376,382 376,282l0,-282l38,0l0,282C414,382 474,432 554,432C635,432 695,382 695,282l0,-282l38,0l0,284C733,416 650,467 561,467z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xAF",
    horizAdvX: 198,
    d: "M20,650l0,-30l158,0l0,30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2212",
    horizAdvX: 502,
    d: "M58,330l0,-35l366,0l0,35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD7",
    horizAdvX: 426,
    d: "M349,442l-25,25l-121,-120l-120,120l-25,-25l120,-120l-120,-120l26,-25l120,120l119,-120l25,25l-119,120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "n",
    horizAdvX: 519,
    d: "M256,467C190,467 128,440 95,383l0,77l-37,0l0,-460l37,0l0,281C95,374 159,433 249,433C339,433 404,374 404,281l0,-281l37,0l0,284C441,407 354,467 256,467z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0144",
    horizAdvX: 519,
    d: "M271,615l-41,-88l36,0l44,88M256,467C190,467 128,440 95,383l0,77l-37,0l0,-460l37,0l0,281C95,374 159,433 249,433C339,433 404,374 404,281l0,-281l37,0l0,284C441,407 354,467 256,467z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0148",
    horizAdvX: 519,
    d: "M290,615l-41,-68l-42,68l-38,0l55,-88l49,0l55,88M256,467C190,467 128,440 95,383l0,77l-37,0l0,-460l37,0l0,281C95,374 159,433 249,433C339,433 404,374 404,281l0,-281l37,0l0,284C441,407 354,467 256,467z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 9,
    horizAdvX: 547,
    d: "M485,433C485,565 390,658 266,658C142,658 48,565 48,433C48,300 142,208 266,208C295,208 323,213 348,223l-149,-223l46,0l192,288C464,328 485,375 485,433M86,433C86,544 163,619 266,619C368,619 446,544 446,433C446,321 368,247 266,247C163,247 86,321 86,433z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2260",
    horizAdvX: 502,
    d: "M424,400l0,34l-120,0l43,107l-36,0l-43,-107l-210,0l0,-34l196,0l-62,-157l-134,0l0,-35l119,0l-42,-106l35,0l43,106l211,0l0,35l-197,0l63,157z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF1",
    horizAdvX: 519,
    d: "M123,527l29,0C153,551 166,574 193,574C212,574 226,563 239,549C253,533 271,515 304,515C348,515 372,547 374,591l-29,0C344,566 334,544 304,544C281,544 268,559 257,571C242,588 222,603 193,603C154,603 125,570 123,527M256,467C190,467 128,440 95,383l0,77l-37,0l0,-460l37,0l0,281C95,374 159,433 249,433C339,433 404,374 404,281l0,-281l37,0l0,284C441,407 354,467 256,467z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "#",
    horizAdvX: 698,
    d: "M640,440l0,37l-99,0l37,170l-40,0l-37,-170l-255,0l37,170l-40,0l-37,-170l-130,0l0,-37l122,0l-49,-223l-111,0l0,-37l103,0l-40,-183l40,0l40,183l255,0l-40,-183l40,0l40,183l126,0l0,37l-118,0l49,223M444,217l-255,0l49,223l255,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "o",
    horizAdvX: 576,
    d: "M278,-8C416,-8 510,93 510,230C510,367 416,467 278,467C141,467 46,367 46,230C46,93 141,-8 278,-8M278,28C163,28 85,114 85,230C85,346 163,431 278,431C394,431 471,346 471,230C471,114 394,28 278,28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF3",
    horizAdvX: 576,
    d: "M300,615l-41,-88l36,0l44,88M278,-8C416,-8 510,93 510,230C510,367 416,467 278,467C141,467 46,367 46,230C46,93 141,-8 278,-8M278,28C163,28 85,114 85,230C85,346 163,431 278,431C394,431 471,346 471,230C471,114 394,28 278,28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF4",
    horizAdvX: 576,
    d: "M357,527l-55,88l-49,0l-55,-88l38,0l42,68l41,-68M278,-8C416,-8 510,93 510,230C510,367 416,467 278,467C141,467 46,367 46,230C46,93 141,-8 278,-8M278,28C163,28 85,114 85,230C85,346 163,431 278,431C394,431 471,346 471,230C471,114 394,28 278,28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF6",
    horizAdvX: 576,
    d: "M191,524C205,524 218,535 218,551C218,566 205,576 191,576C178,576 165,566 165,551C165,535 178,524 191,524M364,524C378,524 391,535 391,551C391,566 378,576 364,576C351,576 338,566 338,551C338,535 351,524 364,524M278,-8C416,-8 510,93 510,230C510,367 416,467 278,467C141,467 46,367 46,230C46,93 141,-8 278,-8M278,28C163,28 85,114 85,230C85,346 163,431 278,431C394,431 471,346 471,230C471,114 394,28 278,28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0153",
    horizAdvX: 982,
    d: "M696,467C595,467 521,413 489,329C455,413 378,467 277,467C140,467 46,367 46,230C46,93 140,-8 277,-8C378,-8 456,47 489,132C522,47 600,-8 702,-8C786,-8 855,30 895,91l-29,18C833,59 776,26 702,26C590,26 514,103 507,215l409,0l0,15C916,367 825,467 696,467M696,434C801,434 874,355 880,245l-373,0C513,357 584,434 696,434M277,29C160,29 83,113 83,230C83,347 160,430 277,430C395,430 470,347 470,230C470,113 395,29 277,29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u02DB",
    horizAdvX: 116,
    d: "M95,-104l0,29C61,-89 50,-76 50,-61C50,-29 85,-6 93,0l-28,0C46,-10 20,-34 20,-65C20,-90 40,-120 95,-104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF2",
    horizAdvX: 576,
    d: "M257,615l-40,0l45,-88l35,0M278,-8C416,-8 510,93 510,230C510,367 416,467 278,467C141,467 46,367 46,230C46,93 141,-8 278,-8M278,28C163,28 85,114 85,230C85,346 163,431 278,431C394,431 471,346 471,230C471,114 394,28 278,28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0151",
    horizAdvX: 576,
    d: "M238,615l-41,-88l33,0l47,88M358,615l-41,-88l33,0l48,88M278,-8C416,-8 510,93 510,230C510,367 416,467 278,467C141,467 46,367 46,230C46,93 141,-8 278,-8M278,28C163,28 85,114 85,230C85,346 163,431 278,431C394,431 471,346 471,230C471,114 394,28 278,28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u014D",
    horizAdvX: 576,
    d: "M199,556l0,-30l158,0l0,30M278,-8C416,-8 510,93 510,230C510,367 416,467 278,467C141,467 46,367 46,230C46,93 141,-8 278,-8M278,28C163,28 85,114 85,230C85,346 163,431 278,431C394,431 471,346 471,230C471,114 394,28 278,28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 1,
    horizAdvX: 290,
    d: "M212,650l-193,0l0,-38l153,0l0,-612l40,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u215B",
    horizAdvX: 528,
    d: "M116,650l-97,0l0,-19l77,0l0,-309l20,0M41,0l401,650l-22,0l-401,-650M449,166C487,179 505,209 505,242C505,284 473,326 401,326C329,326 297,284 297,242C297,209 314,179 353,166C312,153 292,121 292,85C292,33 329,-5 401,-5C473,-5 510,33 510,85C510,121 489,153 449,166M316,242C316,275 341,309 401,309C461,309 486,275 486,242C486,205 461,175 401,175C341,175 316,205 316,242M401,13C341,13 311,43 311,86C311,125 341,158 401,158C461,158 490,125 490,86C490,43 461,13 401,13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xBD",
    horizAdvX: 541,
    d: "M116,650l-97,0l0,-19l77,0l0,-309l20,0M43,0l401,650l-22,0l-401,-650M309,18l0,-18l210,0l0,19l-180,0l80,71C452,118 520,173 520,234C520,289 477,321 413,321C362,321 319,294 309,260l18,-7C335,282 372,302 413,302C467,302 500,277 500,233C500,183 440,133 401,98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xBC",
    horizAdvX: 482,
    d: "M116,650l-97,0l0,-19l77,0l0,-309l20,0M43,0l401,650l-22,0l-401,-650M463,92l-38,0l0,230l-20,0l-174,-231l0,-16l174,0l0,-75l20,0l0,75l38,0M253,92l152,202l0,-202z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF8",
    horizAdvX: 576,
    d: "M433,412l38,48l-28,0l-27,-35C379,452 332,467 278,467C141,467 46,367 46,230C46,155 74,91 123,48l-38,-48l28,0l27,34C177,7 224,-8 278,-8C416,-8 510,93 510,230C510,305 482,369 433,412M85,230C85,346 163,431 278,431C323,431 362,418 393,396l-247,-318C107,114 85,168 85,230M278,28C233,28 194,41 163,64l247,318C449,346 471,292 471,230C471,114 394,28 278,28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF5",
    horizAdvX: 576,
    d: "M152,527l29,0C182,551 195,574 222,574C241,574 255,563 268,549C282,533 300,515 333,515C377,515 401,547 403,591l-29,0C373,566 363,544 333,544C310,544 297,559 286,571C271,588 251,603 222,603C183,603 154,570 152,527M278,-8C416,-8 510,93 510,230C510,367 416,467 278,467C141,467 46,367 46,230C46,93 141,-8 278,-8M278,28C163,28 85,114 85,230C85,346 163,431 278,431C394,431 471,346 471,230C471,114 394,28 278,28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "p",
    horizAdvX: 587,
    d: "M292,467C200,467 130,420 95,348l0,112l-37,0l0,-644l37,0l0,295C130,39 200,-8 292,-8C427,-8 521,92 521,229C521,366 427,467 292,467M289,28C172,28 95,112 95,229C95,346 172,431 289,431C406,431 484,346 484,229C484,112 406,28 289,28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB6",
    horizAdvX: 451,
    d: "M213,650l-41,0C84,650 43,592 43,519C43,440 88,390 175,390l0,-390l38,0M336,650l0,-650l38,0l0,650z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "(",
    horizAdvX: 228,
    d: "M126,-48l44,0C45,121 44,522 169,692l-43,0C8,510 8,132 126,-48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ")",
    horizAdvX: 238,
    d: "M92,-48C210,132 210,510 92,692l-43,0C174,522 173,121 48,-48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2202",
    horizAdvX: 570,
    d: "M485,280C463,387 346,569 242,650l-51,0C262,594 336,501 388,409C355,428 317,438 275,438C151,438 58,348 58,215C58,82 151,-9 275,-9C398,-9 493,82 493,215C493,238 490,260 485,280M275,29C173,29 96,104 96,215C96,326 173,400 275,400C350,400 412,360 440,294l3,-10l1,0C451,263 455,240 455,215C455,104 377,29 275,29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "%",
    horizAdvX: 796,
    d: "M195,369C273,369 332,427 332,510C332,594 273,651 195,651C117,651 58,594 58,510C58,427 117,369 195,369M232,0l351,650l-38,0l-351,-650M195,401C135,401 90,445 90,510C90,575 135,619 195,619C256,619 300,575 300,510C300,445 256,401 195,401M582,-1C659,-1 719,57 719,140C719,224 659,281 582,281C503,281 444,224 444,140C444,57 503,-1 582,-1M582,31C522,31 476,75 476,140C476,205 522,249 582,249C642,249 687,205 687,140C687,75 642,31 582,31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ".",
    horizAdvX: 131,
    d: "M65,-1C81,-1 93,11 93,27C93,42 81,54 65,54C50,54 38,42 38,27C38,11 50,-1 65,-1z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB7",
    horizAdvX: 139,
    d: "M70,293C88,293 102,307 102,325C102,343 88,357 70,357C51,357 38,343 38,325C38,307 51,293 70,293z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2030",
    horizAdvX: 1161,
    d: "M195,369C273,369 332,427 332,510C332,594 273,651 195,651C117,651 58,594 58,510C58,427 117,369 195,369M232,0l351,650l-38,0l-351,-650M195,401C135,401 90,445 90,510C90,575 135,619 195,619C256,619 300,575 300,510C300,445 256,401 195,401M582,-1C659,-1 719,57 719,140C719,224 659,281 582,281C503,281 444,224 444,140C444,57 503,-1 582,-1M947,-1C1024,-1 1083,57 1083,140C1083,224 1024,281 947,281C868,281 809,224 809,140C809,57 868,-1 947,-1M582,31C522,31 476,75 476,140C476,205 522,249 582,249C642,249 687,205 687,140C687,75 642,31 582,31M947,31C886,31 841,75 841,140C841,205 886,249 947,249C1007,249 1051,205 1051,140C1051,75 1007,31 947,31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "+",
    horizAdvX: 502,
    d: "M424,339l-165,0l0,166l-35,0l0,-166l-166,0l0,-36l166,0l0,-165l35,0l0,165l165,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB1",
    horizAdvX: 494,
    d: "M255,387l0,97l-35,0l0,-97l-162,0l0,-32l162,0l0,-98l35,0l0,98l162,0l0,32M58,158l359,0l0,32l-359,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u220F",
    horizAdvX: 606,
    d: "M529,649l-118,0l0,1l-38,0l0,-1l-159,0l0,1l-38,0l0,-1l-118,0l0,-38l118,0l0,-611l38,0l0,611l159,0l0,-611l38,0l0,611l118,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "q",
    horizAdvX: 587,
    d: "M472,460l0,-112C437,420 367,467 275,467C140,467 46,366 46,229C46,92 140,-8 275,-8C367,-8 437,39 472,111l0,-295l38,0l0,644M278,28C161,28 83,112 83,229C83,346 161,431 278,431C396,431 472,346 472,229C472,112 396,28 278,28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "?",
    horizAdvX: 484,
    d: "M195,136l40,0l0,24C235,227 277,265 303,291C366,352 417,395 417,486C417,598 327,661 216,661C130,661 43,610 19,537l37,-13C74,583 149,623 216,623C307,623 376,573 376,485C376,406 332,371 269,310C245,287 195,241 195,160M216,48C200,48 188,35 188,20C188,4 200,-8 216,-8C231,-8 244,4 244,20C244,35 231,48 216,48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xBF",
    horizAdvX: 435,
    d: "M220,605C235,605 248,618 248,633C248,649 235,661 220,661C204,661 192,649 192,633C192,618 204,605 220,605M241,524l-40,0l0,-24C201,433 159,395 133,369C70,308 19,266 19,174C19,62 109,-1 220,-1C306,-1 393,50 417,123l-37,14C362,77 286,37 220,37C128,37 59,87 59,175C59,253 103,289 167,350C191,373 241,419 241,500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\"",
    horizAdvX: 258,
    d: "M38,650l8,-99l34,0l9,99M170,650l9,-99l33,0l9,99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u201E",
    horizAdvX: 279,
    d: "M58,45l-20,-99l33,0l38,99M190,45l-20,-99l33,0l38,99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u201C",
    horizAdvX: 279,
    d: "M89,551l20,99l-33,0l-38,-99M221,551l20,99l-33,0l-38,-99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u201D",
    horizAdvX: 279,
    d: "M58,650l-20,-99l33,0l38,99M190,650l-20,-99l33,0l38,99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2018",
    horizAdvX: 147,
    d: "M89,551l20,99l-33,0l-38,-99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2019",
    horizAdvX: 147,
    d: "M58,650l-20,-99l33,0l38,99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u201A",
    horizAdvX: 147,
    d: "M58,45l-20,-94l33,0l38,94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "'",
    horizAdvX: 126,
    d: "M38,650l1,-99l34,0l16,99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "r",
    horizAdvX: 305,
    d: "M95,375l0,85l-37,0l0,-460l37,0l0,273C95,372 168,429 257,431l0,36C189,466 127,435 95,375z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0155",
    horizAdvX: 305,
    d: "M176,615l-41,-88l36,0l44,88M95,375l0,85l-37,0l0,-460l37,0l0,273C95,372 168,429 257,431l0,36C189,466 127,435 95,375z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u221A",
    horizAdvX: 712,
    d: "M635,692l-182,0l-252,-690l-105,285l-38,0l123,-335l41,0l258,706l155,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0159",
    horizAdvX: 305,
    d: "M195,615l-41,-68l-42,68l-38,0l55,-88l49,0l55,88M95,375l0,85l-37,0l0,-460l37,0l0,273C95,372 168,429 257,431l0,36C189,466 127,435 95,375z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xAE",
    horizAdvX: 782,
    d: "M382,658C189,658 58,517 58,325C58,133 189,-8 382,-8C575,-8 705,133 705,325C705,517 575,658 382,658M382,21C201,21 87,155 87,325C87,495 201,629 382,629C563,629 675,495 675,325C675,155 563,21 382,21M430,293C487,293 531,341 531,399C531,459 487,505 430,505l-169,0l0,-366l29,0l0,154l104,0l108,-154l35,0l-108,154M290,476l138,0C468,476 501,444 501,399C501,355 468,322 428,322l-138,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u02DA",
    horizAdvX: 175,
    d: "M93,508C133,508 165,538 165,581C165,626 133,655 93,655C53,655 20,626 20,581C20,538 53,508 93,508M93,534C63,534 47,556 47,581C47,606 63,629 93,629C122,629 139,606 139,581C139,556 122,534 93,534z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "s",
    horizAdvX: 451,
    d: "M36,93C59,29 125,-11 222,-11C334,-11 395,36 395,125C395,223 272,243 225,255C177,267 88,280 88,346C88,402 136,436 217,436C290,436 343,406 356,367l30,14C368,432 306,468 218,468C117,468 51,424 51,345C51,253 164,236 212,224C260,212 358,197 358,124C358,57 312,23 223,23C141,23 85,56 66,107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u015B",
    horizAdvX: 451,
    d: "M240,615l-41,-88l36,0l44,88M36,93C59,29 125,-11 222,-11C334,-11 395,36 395,125C395,223 272,243 225,255C177,267 88,280 88,346C88,402 136,436 217,436C290,436 343,406 356,367l30,14C368,432 306,468 218,468C117,468 51,424 51,345C51,253 164,236 212,224C260,212 358,197 358,124C358,57 312,23 223,23C141,23 85,56 66,107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0161",
    horizAdvX: 451,
    d: "M259,615l-41,-68l-42,68l-38,0l55,-88l49,0l55,88M36,93C59,29 125,-11 222,-11C334,-11 395,36 395,125C395,223 272,243 225,255C177,267 88,280 88,346C88,402 136,436 217,436C290,436 343,406 356,367l30,14C368,432 306,468 218,468C117,468 51,424 51,345C51,253 164,236 212,224C260,212 358,197 358,124C358,57 312,23 223,23C141,23 85,56 66,107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u015F",
    horizAdvX: 451,
    d: "M395,125C395,223 272,243 225,255C177,267 88,280 88,346C88,402 136,436 217,436C290,436 343,406 356,367l30,14C368,432 306,468 218,468C117,468 51,424 51,345C51,253 164,236 212,224C260,212 358,197 358,124C358,57 312,23 223,23C141,23 85,56 66,107l-30,-14C58,33 117,-6 205,-11l-18,-29l-1,0l0,-26C192,-62 203,-61 211,-61C234,-61 249,-71 249,-84C249,-98 234,-107 216,-107C201,-107 186,-106 174,-96l0,-30C188,-132 202,-134 216,-134C260,-134 277,-108 277,-84C277,-63 261,-39 219,-36l15,25C338,-8 395,39 395,125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xA7",
    horizAdvX: 489,
    d: "M304,219C376,232 412,273 412,330C412,430 295,444 245,457C195,470 114,490 114,551C114,606 160,640 243,640C312,640 353,615 365,575l33,11C381,638 329,674 243,674C143,674 80,627 80,551C80,489 130,459 178,442C114,428 78,387 78,326C78,237 184,217 234,204C284,191 376,176 376,104C376,39 330,3 241,3C164,3 110,29 90,85l-32,-11C81,8 144,-31 241,-31C346,-31 410,13 410,104C410,172 355,202 304,219M237,419C310,419 378,396 378,331C378,282 337,245 247,245C179,245 112,271 112,328C112,385 154,419 237,419z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ";",
    horizAdvX: 159,
    d: "M85,287C100,287 112,300 112,315C112,330 100,343 85,343C69,343 57,330 57,315C57,300 69,287 85,287M68,45l-30,-117l33,0l48,117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 7,
    horizAdvX: 454,
    d: "M79,0l43,0l285,617l0,33l-378,0l0,-38l333,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u215E",
    horizAdvX: 543,
    d: "M41,0l401,650l-22,0l-401,-650M68,323l21,0l144,311l0,16l-190,0l0,-19l167,0M463,166C501,179 519,209 519,242C519,284 487,326 415,326C343,326 311,284 311,242C311,209 328,179 367,166C326,153 306,121 306,85C306,33 343,-5 415,-5C487,-5 524,33 524,85C524,121 503,153 463,166M330,242C330,275 355,309 415,309C475,309 500,275 500,242C500,205 475,175 415,175C355,175 330,205 330,242M415,13C355,13 325,43 325,86C325,125 355,158 415,158C475,158 504,125 504,86C504,43 475,13 415,13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 6,
    horizAdvX: 547,
    d: "M267,442C238,442 210,437 185,427l153,223l-46,0l-204,-298C63,315 48,269 48,217C48,85 143,-8 267,-8C391,-8 485,85 485,217C485,350 391,442 267,442M267,31C164,31 86,106 86,217C86,329 164,404 267,404C369,404 446,329 446,217C446,106 369,31 267,31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "/",
    horizAdvX: 292,
    d: "M38,-47l40,0l212,739l-40,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: " ",
    horizAdvX: 200
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xA3",
    horizAdvX: 519,
    d: "M190,34C272,82 272,186 225,317l175,0l0,29l-186,0C212,352 209,357 207,363C127,555 230,667 440,623l0,35C208,702 77,578 169,357l5,-11l-107,0l0,-29l118,0C248,147 237,34 58,34l0,-34l383,0l0,34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2211",
    horizAdvX: 539,
    d: "M462,658l-404,0l0,-36l253,-300l-253,-295l0,-35l404,0l0,38l-351,0l251,292l-252,298l352,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "t",
    horizAdvX: 300,
    d: "M251,428l0,32l-118,0l0,139l-38,0l0,-139l-67,0l0,-32l67,0l0,-333C95,34 134,0 190,0l56,0l0,33l-47,0C161,33 133,53 133,98l0,330z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0165",
    horizAdvX: 300,
    d: "M153,738l-41,-68l-42,68l-38,0l55,-88l49,0l55,88M251,428l0,32l-118,0l0,139l-38,0l0,-139l-67,0l0,-32l67,0l0,-333C95,34 134,0 190,0l56,0l0,33l-47,0C161,33 133,53 133,98l0,330z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 3,
    horizAdvX: 533,
    d: "M245,410C234,410 223,410 212,409l246,204l0,37l-374,0l0,-38l315,0l-269,-223l0,-35C162,368 207,374 244,374C348,374 431,314 431,203C431,97 348,31 244,31C170,31 103,62 68,110l-30,-24C78,28 160,-8 244,-8C367,-8 471,70 471,203C471,340 364,410 245,410z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u215C",
    horizAdvX: 596,
    d: "M122,530l-16,0l122,102l0,18l-186,0l0,-19l157,0l-134,-111l0,-18C81,509 103,512 122,512C173,512 215,483 215,427C215,374 173,341 122,341C85,341 51,357 34,381l-15,-12C39,340 80,322 122,322C183,322 235,361 235,427C235,495 181,530 122,530M108,0l401,650l-22,0l-401,-650M517,166C555,179 573,209 573,242C573,284 541,326 469,326C397,326 365,284 365,242C365,209 382,179 421,166C380,153 360,121 360,85C360,33 397,-5 469,-5C541,-5 578,33 578,85C578,121 557,153 517,166M384,242C384,275 409,309 469,309C529,309 554,275 554,242C554,205 529,175 469,175C409,175 384,205 384,242M469,13C409,13 379,43 379,86C379,125 409,158 469,158C529,158 558,125 558,86C558,43 529,13 469,13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xBE",
    horizAdvX: 536,
    d: "M122,530l-16,0l122,102l0,18l-186,0l0,-19l157,0l-134,-111l0,-18C81,509 103,512 122,512C173,512 215,483 215,427C215,374 173,341 122,341C85,341 51,357 34,381l-15,-12C39,340 80,322 122,322C183,322 235,361 235,427C235,495 181,530 122,530M109,0l401,650l-22,0l-401,-650M517,92l-38,0l0,230l-20,0l-174,-231l0,-16l174,0l0,-75l20,0l0,75l38,0M307,92l152,202l0,-202z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u02DC",
    horizAdvX: 291,
    d: "M20,581l29,0C50,605 63,628 90,628C109,628 123,617 136,603C150,587 168,569 201,569C245,569 269,601 271,645l-29,0C241,620 231,598 201,598C178,598 165,613 154,625C139,642 119,657 90,657C51,657 22,624 20,581z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0303",
    horizAdvX: 0,
    d: "M-271,581l29,0C-241,605 -228,628 -201,628C-182,628 -168,617 -155,603C-141,587 -123,569 -90,569C-46,569 -22,601 -20,645l-29,0C-50,620 -60,598 -90,598C-113,598 -126,613 -137,625C-152,642 -172,657 -201,657C-240,657 -269,624 -271,581z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2122",
    horizAdvX: 1315,
    d: "M524,650l-486,0l0,-38l223,0l0,-612l40,0l0,612l223,0M1238,650l-46,0l-253,-503l-253,503l-46,0l0,-650l39,0l0,579l246,-496l28,0l245,496l0,-579l40,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 2,
    horizAdvX: 520,
    d: "M38,36l1,-36l432,0l0,38l-370,0l164,146C332,242 473,355 473,481C473,593 384,658 253,658C147,658 60,604 38,534l37,-14C93,578 168,619 253,619C363,619 432,569 432,479C432,375 308,272 228,202z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "u",
    horizAdvX: 519,
    d: "M404,460l0,-282C404,85 340,26 250,26C160,26 95,85 95,178l0,282l-37,0l0,-285C58,52 145,-8 243,-8C309,-8 371,19 404,76l0,-76l37,0l0,460z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xFA",
    horizAdvX: 519,
    d: "M280,615l-41,-88l36,0l44,88M404,460l0,-282C404,85 340,26 250,26C160,26 95,85 95,178l0,282l-37,0l0,-285C58,52 145,-8 243,-8C309,-8 371,19 404,76l0,-76l37,0l0,460z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xFB",
    horizAdvX: 519,
    d: "M337,527l-55,88l-49,0l-55,-88l38,0l42,68l41,-68M404,460l0,-282C404,85 340,26 250,26C160,26 95,85 95,178l0,282l-37,0l0,-285C58,52 145,-8 243,-8C309,-8 371,19 404,76l0,-76l37,0l0,460z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xFC",
    horizAdvX: 519,
    d: "M171,524C185,524 198,535 198,551C198,566 185,576 171,576C158,576 145,566 145,551C145,535 158,524 171,524M344,524C358,524 371,535 371,551C371,566 358,576 344,576C331,576 318,566 318,551C318,535 331,524 344,524M404,460l0,-282C404,85 340,26 250,26C160,26 95,85 95,178l0,282l-37,0l0,-285C58,52 145,-8 243,-8C309,-8 371,19 404,76l0,-76l37,0l0,460z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF9",
    horizAdvX: 519,
    d: "M237,615l-40,0l45,-88l35,0M404,460l0,-282C404,85 340,26 250,26C160,26 95,85 95,178l0,282l-37,0l0,-285C58,52 145,-8 243,-8C309,-8 371,19 404,76l0,-76l37,0l0,460z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0171",
    horizAdvX: 519,
    d: "M218,615l-41,-88l33,0l47,88M338,615l-41,-88l33,0l48,88M404,460l0,-282C404,85 340,26 250,26C160,26 95,85 95,178l0,282l-37,0l0,-285C58,52 145,-8 243,-8C309,-8 371,19 404,76l0,-76l37,0l0,460z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u016B",
    horizAdvX: 519,
    d: "M179,556l0,-30l158,0l0,30M404,460l0,-282C404,85 340,26 250,26C160,26 95,85 95,178l0,282l-37,0l0,-285C58,52 145,-8 243,-8C309,-8 371,19 404,76l0,-76l37,0l0,460z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "_",
    horizAdvX: 470,
    d: "M58,38l0,-38l334,0l0,38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB2",
    horizAdvX: 347,
    d: "M38,284l1,-22l260,0l0,23l-223,0l99,88C215,408 300,476 300,552C300,620 247,659 168,659C104,659 51,626 38,584l22,-8C71,611 116,636 168,636C234,636 276,605 276,551C276,488 201,426 153,384z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB3",
    horizAdvX: 361,
    d: "M163,505l-20,0l148,123l0,22l-225,0l0,-23l190,0l-163,-134l0,-22C113,480 140,484 162,484C225,484 275,447 275,380C275,317 225,277 162,277C118,277 77,295 56,324l-18,-14C62,275 111,253 162,253C236,253 299,300 299,380C299,463 235,505 163,505z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB9",
    horizAdvX: 214,
    d: "M136,650l-117,0l0,-23l93,0l0,-369l24,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0122",
    horizAdvX: 752,
    d: "M684,310l0,15l-313,0l0,-38l270,0C628,136 527,32 372,32C202,32 87,156 87,325C87,494 202,618 372,618C470,618 551,576 601,506l34,22C579,608 487,658 372,658C179,658 48,518 48,325C48,132 179,-8 372,-8C560,-8 678,125 684,310M358,-65l-41,-88l35,0l45,88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0123",
    horizAdvX: 587,
    d: "M305,602l-25,0C269,587 254,570 254,551C254,537 265,525 281,525C296,525 307,537 307,551C307,564 298,573 287,576C291,584 299,594 305,602M472,460l0,-111C437,421 367,467 275,467C140,467 46,367 46,230C46,93 140,-8 275,-8C367,-8 437,39 472,111l0,-76C472,-83 384,-152 271,-152C205,-152 149,-128 111,-84l-27,-22C126,-156 193,-186 271,-186C412,-186 510,-97 510,35l0,425M278,28C161,28 83,113 83,230C83,347 161,431 278,431C395,431 472,347 472,230C472,113 395,28 278,28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0136",
    horizAdvX: 512,
    d: "M475,0l-340,325l327,325l-52,0l-313,-311l0,311l-39,0l0,-650l39,0l0,312l326,-312M231,-64l-41,-88l35,0l45,88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0137",
    horizAdvX: 439,
    d: "M402,0l-269,242l248,218l-50,0l-236,-207l0,397l-37,0l0,-650l37,0l0,231l257,-231M201,-64l-41,-88l35,0l45,88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u013B",
    horizAdvX: 521,
    d: "M97,38l0,612l-39,0l0,-650l406,0l0,38M243,-64l-41,-88l35,0l45,88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u013C",
    horizAdvX: 173,
    d: "M95,0l0,650l-37,0l0,-650M58,-64l-41,-88l35,0l45,88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0145",
    horizAdvX: 616,
    d: "M499,650l0,-581l-402,581l-39,0l0,-650l40,0l0,583l402,-583l39,0l0,650M290,-64l-41,-88l35,0l45,88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0146",
    horizAdvX: 519,
    d: "M256,467C190,467 128,440 95,383l0,77l-37,0l0,-460l37,0l0,281C95,374 159,433 249,433C339,433 404,374 404,281l0,-281l37,0l0,284C441,407 354,467 256,467M231,-64l-41,-88l35,0l45,88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0156",
    horizAdvX: 596,
    d: "M539,0l-200,275l11,0C450,275 528,355 528,462C528,569 450,650 350,650l-292,0l0,-650l39,0l0,275l194,0l200,-275M97,611l250,0C432,611 488,541 488,462C488,383 432,314 347,314l-250,0M248,-64l-41,-88l35,0l45,88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0157",
    horizAdvX: 305,
    d: "M95,375l0,85l-37,0l0,-460l37,0l0,273C95,372 168,429 257,431l0,36C189,466 127,435 95,375M57,-64l-41,-88l35,0l45,88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0162",
    horizAdvX: 582,
    d: "M301,0l0,612l223,0l0,38l-486,0l0,-38l223,0l0,-612l5,0l-21,-35l-1,0l0,-26C250,-57 261,-56 269,-56C292,-56 307,-66 307,-79C307,-93 292,-102 274,-102C259,-102 244,-101 232,-91l0,-30C246,-127 260,-129 274,-129C318,-129 335,-103 335,-79C335,-58 319,-34 277,-31l18,31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0163",
    horizAdvX: 300,
    d: "M251,428l0,32l-118,0l0,139l-38,0l0,-139l-67,0l0,-32l67,0l0,-333C95,39 128,6 176,1l-21,-35l-1,0l0,-26C160,-56 171,-55 179,-55C202,-55 217,-65 217,-78C217,-92 202,-101 184,-101C169,-101 154,-100 142,-90l0,-30C156,-126 170,-128 184,-128C228,-128 245,-102 245,-78C245,-57 229,-33 187,-30l18,30l41,0l0,33l-47,0C161,33 133,53 133,98l0,330z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u01CD",
    horizAdvX: 636,
    d: "M354,798l-41,-68l-42,68l-38,0l55,-88l49,0l55,88M556,0l42,0l-269,650l-32,0l-269,-650l42,0l81,195l324,0M166,233l147,355l147,-355z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u01CE",
    horizAdvX: 587,
    d: "M333,615l-41,-68l-42,68l-38,0l55,-88l49,0l55,88M472,460l0,-111C437,421 367,467 275,467C140,467 46,367 46,230C46,93 140,-8 275,-8C367,-8 437,39 472,111l0,-111l38,0l0,460M278,28C161,28 83,113 83,230C83,347 161,431 278,431C396,431 472,347 472,230C472,113 396,28 278,28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u01CF",
    horizAdvX: 175,
    d: "M118,798l-41,-68l-42,68l-38,0l55,-88l49,0l55,88M97,0l0,650l-39,0l0,-650z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u01D0",
    horizAdvX: 190,
    d: "M126,615l-41,-68l-42,68l-38,0l55,-88l49,0l55,88M104,0l0,460l-38,0l0,-460z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u01D1",
    horizAdvX: 757,
    d: "M413,798l-41,-68l-42,68l-38,0l55,-88l49,0l55,88M372,-8C565,-8 695,132 695,325C695,518 565,658 372,658C179,658 48,518 48,325C48,132 179,-8 372,-8M372,32C202,32 87,156 87,325C87,494 202,618 372,618C543,618 655,494 655,325C655,156 543,32 372,32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u01D2",
    horizAdvX: 576,
    d: "M319,615l-41,-68l-42,68l-38,0l55,-88l49,0l55,88M278,-8C416,-8 510,93 510,230C510,367 416,467 278,467C141,467 46,367 46,230C46,93 141,-8 278,-8M278,28C163,28 85,114 85,230C85,346 163,431 278,431C394,431 471,346 471,230C471,114 394,28 278,28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u01D3",
    horizAdvX: 614,
    d: "M347,798l-41,-68l-42,68l-38,0l55,-88l49,0l55,88M497,650l0,-424C497,107 421,31 297,31C173,31 97,107 97,226l0,424l-39,0l0,-427C58,89 147,-8 297,-8C447,-8 537,89 537,223l0,427z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u01D4",
    horizAdvX: 519,
    d: "M299,615l-41,-68l-42,68l-38,0l55,-88l49,0l55,88M404,460l0,-282C404,85 340,26 250,26C160,26 95,85 95,178l0,282l-37,0l0,-285C58,52 145,-8 243,-8C309,-8 371,19 404,76l0,-76l37,0l0,460z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0218",
    horizAdvX: 595,
    d: "M38,134C69,45 162,-11 295,-11C451,-11 537,54 537,178C537,312 368,342 304,359C232,376 102,394 102,491C102,573 170,621 292,621C394,621 472,580 491,522l35,16C503,610 412,661 295,661C151,661 59,601 59,490C59,362 215,339 286,322C351,305 495,283 495,177C495,79 431,29 297,29C180,29 99,77 72,153M280,-70l-41,-88l35,0l45,88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0219",
    horizAdvX: 451,
    d: "M36,93C59,29 125,-11 222,-11C334,-11 395,36 395,125C395,223 272,243 225,255C177,267 88,280 88,346C88,402 136,436 217,436C290,436 343,406 356,367l30,14C368,432 306,468 218,468C117,468 51,424 51,345C51,253 164,236 212,224C260,212 358,197 358,124C358,57 312,23 223,23C141,23 85,56 66,107M205,-67l-41,-88l35,0l45,88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u021A",
    horizAdvX: 582,
    d: "M524,650l-486,0l0,-38l223,0l0,-612l40,0l0,612l223,0M263,-62l-41,-88l35,0l45,88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u021B",
    horizAdvX: 300,
    d: "M251,428l0,32l-118,0l0,139l-38,0l0,-139l-67,0l0,-32l67,0l0,-333C95,34 134,0 190,0l56,0l0,33l-47,0C161,33 133,53 133,98l0,330M173,-61l-41,-88l35,0l45,88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0302",
    horizAdvX: 0,
    d: "M-20,562l-55,88l-49,0l-55,-88l38,0l42,68l41,-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0304",
    horizAdvX: 0,
    d: "M-178,650l0,-30l158,0l0,30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0306",
    horizAdvX: 0,
    d: "M-20,650l-29,0l0,-3C-49,621 -67,599 -96,599C-126,599 -144,621 -144,647l0,3l-29,0l0,-3C-173,602 -138,571 -96,571C-54,571 -20,602 -20,647z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0307",
    horizAdvX: 0,
    d: "M-47,604C-33,604 -20,615 -20,631C-20,646 -33,656 -47,656C-60,656 -73,646 -73,631C-73,615 -60,604 -47,604z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0308",
    horizAdvX: 0,
    d: "M-221,604C-207,604 -194,615 -194,631C-194,646 -207,656 -221,656C-234,656 -247,646 -247,631C-247,615 -234,604 -221,604M-48,604C-34,604 -21,615 -21,631C-21,646 -34,656 -48,656C-61,656 -74,646 -74,631C-74,615 -61,604 -48,604z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u030A",
    horizAdvX: 0,
    d: "M-87,518C-50,518 -20,546 -20,586C-20,628 -50,655 -87,655C-124,655 -155,628 -155,586C-155,546 -124,518 -87,518M-87,543C-113,543 -128,565 -128,586C-128,607 -113,629 -87,629C-61,629 -47,607 -47,586C-47,565 -61,543 -87,543z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u030B",
    horizAdvX: 0,
    d: "M-180,650l-41,-88l33,0l47,88M-60,650l-41,-88l33,0l48,88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u030C",
    horizAdvX: 0,
    d: "M-58,650l-41,-68l-42,68l-38,0l55,-88l49,0l55,88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0312",
    horizAdvX: 0,
    d: "M-22,658l-25,0C-58,643 -73,626 -73,607C-73,593 -62,581 -46,581C-31,581 -20,593 -20,607C-20,620 -29,629 -40,632C-36,640 -28,650 -22,658z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0326",
    horizAdvX: 0,
    d: "M-59,0l-41,-88l35,0l45,88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0327",
    horizAdvX: 0,
    d: "M-78,-34l20,34l-29,0l-23,-38l-1,0l0,-26C-105,-60 -94,-59 -86,-59C-63,-59 -48,-69 -48,-82C-48,-96 -63,-105 -81,-105C-96,-105 -111,-104 -123,-94l0,-30C-109,-130 -95,-132 -81,-132C-37,-132 -20,-106 -20,-82C-20,-61 -36,-37 -78,-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0328",
    horizAdvX: 0,
    d: "M-21,-104l0,29C-55,-89 -66,-76 -66,-61C-66,-29 -32,-6 -24,0l-27,0C-71,-10 -97,-34 -97,-65C-97,-90 -76,-120 -21,-104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0331",
    horizAdvX: 0,
    d: "M-176,0l0,-30l156,0l0,30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0394",
    horizAdvX: 662,
    d: "M337,650l-32,0l-247,-613l0,-37l527,0l0,37M101,37l219,553l221,-553z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u03A9",
    horizAdvX: 786,
    d: "M545,42C639,99 706,200 706,325C706,518 577,658 384,658C191,658 60,518 60,325C60,199 128,98 224,42l-166,0l0,-38l251,0l0,41C185,85 99,195 99,326C99,489 209,619 384,619C559,619 667,489 667,326C667,193 580,83 456,43l0,-39l253,0l0,38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u1E04",
    horizAdvX: 603,
    d: "M441,338C495,363 530,413 530,483C530,586 454,650 354,650l-296,0l0,-650l319,0C477,0 554,73 554,176C554,256 508,315 441,338M97,612l253,0C435,612 490,559 490,482C490,404 435,352 350,352l-253,0M373,38l-276,0l0,278l276,0C458,316 514,255 514,177C514,100 459,38 373,38M266,-108C280,-108 293,-97 293,-82C293,-67 280,-56 266,-56C253,-56 240,-67 240,-82C240,-97 253,-108 266,-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u1E05",
    horizAdvX: 587,
    d: "M292,467C200,467 130,421 95,349l0,301l-37,0l0,-650l37,0l0,111C130,39 200,-8 292,-8C427,-8 521,93 521,230C521,367 427,467 292,467M289,28C172,28 95,113 95,230C95,347 172,431 289,431C406,431 484,347 484,230C484,113 406,28 289,28M291,-116C305,-116 318,-105 318,-90C318,-75 305,-64 291,-64C278,-64 265,-75 265,-90C265,-105 278,-116 291,-116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u1E0C",
    horizAdvX: 648,
    d: "M264,650l-206,0l0,-650l206,0C457,0 586,132 586,325C586,518 457,650 264,650M264,39l-167,0l0,572l167,0C426,611 546,501 546,325C546,149 426,39 264,39M258,-108C272,-108 285,-97 285,-82C285,-67 272,-56 258,-56C245,-56 232,-67 232,-82C232,-97 245,-108 258,-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u1E0D",
    horizAdvX: 587,
    d: "M472,650l0,-301C437,421 367,467 275,467C140,467 46,367 46,230C46,93 140,-8 275,-8C367,-8 437,39 472,111l0,-111l38,0l0,650M278,28C161,28 83,113 83,230C83,347 161,431 278,431C396,431 472,347 472,230C472,113 396,28 278,28M280,-116C294,-116 307,-105 307,-90C307,-75 294,-64 280,-64C267,-64 254,-75 254,-90C254,-105 267,-116 280,-116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u1E24",
    horizAdvX: 617,
    d: "M499,650l0,-306l-402,0l0,306l-39,0l0,-650l39,0l0,305l402,0l0,-305l40,0l0,650M295,-107C309,-107 322,-96 322,-81C322,-66 309,-55 295,-55C282,-55 269,-66 269,-81C269,-96 282,-107 295,-107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u1E25",
    horizAdvX: 519,
    d: "M256,467C190,467 128,440 95,383l0,267l-37,0l0,-650l37,0l0,281C95,374 159,433 249,433C339,433 404,374 404,281l0,-281l37,0l0,284C441,407 354,467 256,467M258,-108C272,-108 285,-97 285,-82C285,-67 272,-56 258,-56C245,-56 232,-67 232,-82C232,-97 245,-108 258,-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u1E36",
    horizAdvX: 521,
    d: "M97,38l0,612l-39,0l0,-650l406,0l0,38M261,-108C275,-108 288,-97 288,-82C288,-67 275,-56 261,-56C248,-56 235,-67 235,-82C235,-97 248,-108 261,-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u1E37",
    horizAdvX: 173,
    d: "M95,0l0,650l-37,0l0,-650M76,-108C90,-108 103,-97 103,-82C103,-67 90,-56 76,-56C63,-56 50,-67 50,-82C50,-97 63,-108 76,-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u1E3E",
    horizAdvX: 733,
    d: "M380,798l-41,-88l36,0l44,88M656,650l-46,0l-253,-503l-253,503l-46,0l0,-650l39,0l0,579l246,-496l28,0l245,496l0,-579l40,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u1E3F",
    horizAdvX: 810,
    d: "M417,617l-41,-88l36,0l44,88M561,467C494,467 429,438 400,366C373,438 309,467 242,467C183,467 126,443 95,389l0,71l-37,0l0,-460l37,0l0,282C95,382 155,432 236,432C316,432 376,382 376,282l0,-282l38,0l0,282C414,382 474,432 554,432C635,432 695,382 695,282l0,-282l38,0l0,284C733,416 650,467 561,467z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u1E44",
    horizAdvX: 616,
    d: "M308,707C322,707 335,718 335,734C335,749 322,759 308,759C295,759 282,749 282,734C282,718 295,707 308,707M499,650l0,-581l-402,581l-39,0l0,-650l40,0l0,583l402,-583l39,0l0,650z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u1E45",
    horizAdvX: 519,
    d: "M249,524C263,524 276,535 276,551C276,566 263,576 249,576C236,576 223,566 223,551C223,535 236,524 249,524M256,467C190,467 128,440 95,383l0,77l-37,0l0,-460l37,0l0,281C95,374 159,433 249,433C339,433 404,374 404,281l0,-281l37,0l0,284C441,407 354,467 256,467z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u1E46",
    horizAdvX: 616,
    d: "M499,650l0,-581l-402,581l-39,0l0,-650l40,0l0,583l402,-583l39,0l0,650M308,-108C322,-108 335,-97 335,-82C335,-67 322,-56 308,-56C295,-56 282,-67 282,-82C282,-97 295,-108 308,-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u1E47",
    horizAdvX: 519,
    d: "M256,467C190,467 128,440 95,383l0,77l-37,0l0,-460l37,0l0,281C95,374 159,433 249,433C339,433 404,374 404,281l0,-281l37,0l0,284C441,407 354,467 256,467M249,-108C263,-108 276,-97 276,-82C276,-67 263,-56 249,-56C236,-56 223,-67 223,-82C223,-97 236,-108 249,-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u1E62",
    horizAdvX: 595,
    d: "M38,134C69,45 162,-11 295,-11C451,-11 537,54 537,178C537,312 368,342 304,359C232,376 102,394 102,491C102,573 170,621 292,621C394,621 472,580 491,522l35,16C503,610 412,661 295,661C151,661 59,601 59,490C59,362 215,339 286,322C351,305 495,283 495,177C495,79 431,29 297,29C180,29 99,77 72,153M298,-114C312,-114 325,-103 325,-88C325,-73 312,-62 298,-62C285,-62 272,-73 272,-88C272,-103 285,-114 298,-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u1E6C",
    horizAdvX: 582,
    d: "M524,650l-486,0l0,-38l223,0l0,-612l40,0l0,612l223,0M281,-106C295,-106 308,-95 308,-80C308,-65 295,-54 281,-54C268,-54 255,-65 255,-80C255,-95 268,-106 281,-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u1E6D",
    horizAdvX: 300,
    d: "M251,428l0,32l-118,0l0,139l-38,0l0,-139l-67,0l0,-32l67,0l0,-333C95,34 134,0 190,0l56,0l0,33l-47,0C161,33 133,53 133,98l0,330M191,-105C205,-105 218,-94 218,-79C218,-64 205,-53 191,-53C178,-53 165,-64 165,-79C165,-94 178,-105 191,-105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u1E92",
    horizAdvX: 537,
    d: "M480,614l0,36l-426,0l0,-38l378,0l-384,-576l0,-36l424,0l0,38l-377,0M267,-108C281,-108 294,-97 294,-82C294,-67 281,-56 267,-56C254,-56 241,-67 241,-82C241,-97 254,-108 267,-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u1E93",
    horizAdvX: 433,
    d: "M376,460l-332,0l0,-34l286,0l-292,-395l0,-31l332,0l0,34l-286,0l292,394M207,-108C221,-108 234,-97 234,-82C234,-67 221,-56 207,-56C194,-56 181,-67 181,-82C181,-97 194,-108 207,-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u1EA0",
    horizAdvX: 636,
    d: "M556,0l42,0l-269,650l-32,0l-269,-650l42,0l81,195l324,0M166,233l147,355l147,-355M318,-108C332,-108 345,-97 345,-82C345,-67 332,-56 318,-56C305,-56 292,-67 292,-82C292,-97 305,-108 318,-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u1EA1",
    horizAdvX: 587,
    d: "M472,460l0,-111C437,421 367,467 275,467C140,467 46,367 46,230C46,93 140,-8 275,-8C367,-8 437,39 472,111l0,-111l38,0l0,460M278,28C161,28 83,113 83,230C83,347 161,431 278,431C396,431 472,347 472,230C472,113 396,28 278,28M292,-111C306,-111 319,-100 319,-85C319,-70 306,-59 292,-59C279,-59 266,-70 266,-85C266,-100 279,-111 292,-111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u1EB8",
    horizAdvX: 538,
    d: "M466,612l0,38l-408,0l0,-650l408,0l0,38l-369,0l0,267l348,0l0,38l-348,0l0,269M269,-106C283,-106 296,-95 296,-80C296,-65 283,-54 269,-54C256,-54 243,-65 243,-80C243,-95 256,-106 269,-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u1EB9",
    horizAdvX: 558,
    d: "M272,467C135,467 46,367 46,230C46,93 140,-8 278,-8C362,-8 430,29 470,90l-28,19C409,59 352,26 278,26C166,26 90,103 83,215l408,0l0,15C491,367 401,467 272,467M272,434C377,434 450,355 456,245l-373,0C89,357 159,434 272,434M277,-113C291,-113 304,-102 304,-87C304,-72 291,-61 277,-61C264,-61 251,-72 251,-87C251,-102 264,-113 277,-113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u1EBC",
    horizAdvX: 538,
    d: "M143,710l29,0C173,734 186,757 213,757C232,757 246,746 259,732C273,716 291,698 324,698C368,698 392,730 394,774l-29,0C364,749 354,727 324,727C301,727 288,742 277,754C262,771 242,786 213,786C174,786 145,753 143,710M466,612l0,38l-408,0l0,-650l408,0l0,38l-369,0l0,267l348,0l0,38l-348,0l0,269z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u1EBD",
    horizAdvX: 558,
    d: "M146,527l29,0C176,551 189,574 216,574C235,574 249,563 262,549C276,533 294,515 327,515C371,515 395,547 397,591l-29,0C367,566 357,544 327,544C304,544 291,559 280,571C265,588 245,603 216,603C177,603 148,570 146,527M272,467C135,467 46,367 46,230C46,93 140,-8 278,-8C362,-8 430,29 470,90l-28,19C409,59 352,26 278,26C166,26 90,103 83,215l408,0l0,15C491,367 401,467 272,467M272,434C377,434 450,355 456,245l-373,0C89,357 159,434 272,434z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u1ECA",
    horizAdvX: 175,
    d: "M97,0l0,650l-39,0l0,-650M77,-108C91,-108 104,-97 104,-82C104,-67 91,-56 77,-56C64,-56 51,-67 51,-82C51,-97 64,-108 77,-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u1ECB",
    horizAdvX: 191,
    d: "M86,578C100,578 114,590 114,606C114,623 100,634 86,634C71,634 58,623 58,606C58,590 71,578 86,578M104,0l1,460l-38,0l0,-460M86,-116C100,-116 113,-105 113,-90C113,-75 100,-64 86,-64C73,-64 60,-75 60,-90C60,-105 73,-116 86,-116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u1ECC",
    horizAdvX: 757,
    d: "M372,-8C565,-8 695,132 695,325C695,518 565,658 372,658C179,658 48,518 48,325C48,132 179,-8 372,-8M372,32C202,32 87,156 87,325C87,494 202,618 372,618C543,618 655,494 655,325C655,156 543,32 372,32M372,-116C386,-116 399,-105 399,-90C399,-75 386,-64 372,-64C359,-64 346,-75 346,-90C346,-105 359,-116 372,-116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u1ECD",
    horizAdvX: 576,
    d: "M278,-8C416,-8 510,93 510,230C510,367 416,467 278,467C141,467 46,367 46,230C46,93 141,-8 278,-8M278,28C163,28 85,114 85,230C85,346 163,431 278,431C394,431 471,346 471,230C471,114 394,28 278,28M278,-116C292,-116 305,-105 305,-90C305,-75 292,-64 278,-64C265,-64 252,-75 252,-90C252,-105 265,-116 278,-116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u1EE4",
    horizAdvX: 614,
    d: "M497,650l0,-424C497,107 421,31 297,31C173,31 97,107 97,226l0,424l-39,0l0,-427C58,89 147,-8 297,-8C447,-8 537,89 537,223l0,427M297,-108C311,-108 324,-97 324,-82C324,-67 311,-56 297,-56C284,-56 271,-67 271,-82C271,-97 284,-108 297,-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u1EE5",
    horizAdvX: 519,
    d: "M404,460l0,-282C404,85 340,26 250,26C160,26 95,85 95,178l0,282l-37,0l0,-285C58,52 145,-8 243,-8C309,-8 371,19 404,76l0,-76l37,0l0,460M250,-115C264,-115 277,-104 277,-89C277,-74 264,-63 250,-63C237,-63 224,-74 224,-89C224,-104 237,-115 250,-115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u1EF4",
    horizAdvX: 563,
    d: "M526,650l-47,0l-207,-318l-207,318l-47,0l235,-361l0,-289l39,0l0,291M272,-108C286,-108 299,-97 299,-82C299,-67 286,-56 272,-56C259,-56 246,-67 246,-82C246,-97 259,-108 272,-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u1EF5",
    horizAdvX: 458,
    d: "M380,460l-162,-408l-161,408l-39,0l181,-459l-73,-185l38,0l256,644M266,-167C280,-167 293,-156 293,-141C293,-126 280,-115 266,-115C253,-115 240,-126 240,-141C240,-156 253,-167 266,-167z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u1EF8",
    horizAdvX: 563,
    d: "M146,710l29,0C176,734 189,757 216,757C235,757 249,746 262,732C276,716 294,698 327,698C371,698 395,730 397,774l-29,0C367,749 357,727 327,727C304,727 291,742 280,754C265,771 245,786 216,786C177,786 148,753 146,710M526,650l-47,0l-207,-318l-207,318l-47,0l235,-361l0,-289l39,0l0,291z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u1EF9",
    horizAdvX: 458,
    d: "M92,527l29,0C122,551 135,574 162,574C181,574 195,563 208,549C222,533 240,515 273,515C317,515 341,547 343,591l-29,0C313,566 303,544 273,544C250,544 237,559 226,571C211,588 191,603 162,603C123,603 94,570 92,527M380,460l-162,-408l-161,408l-39,0l181,-459l-73,-185l38,0l256,644z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2070",
    horizAdvX: 418,
    d: "M204,253C304,253 360,338 360,455C360,573 304,658 204,658C105,658 48,573 48,455C48,338 105,253 204,253M204,277C120,277 72,351 72,455C72,560 120,633 204,633C289,633 336,560 336,455C336,351 289,277 204,277z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2074",
    horizAdvX: 369,
    d: "M321,370l-46,0l0,280l-25,0l-212,-281l0,-20l212,0l0,-91l25,0l0,91l46,0M65,370l185,246l0,-246z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2075",
    horizAdvX: 360,
    d: "M161,511C140,511 113,507 91,500l19,131l172,0l0,23l-192,0l-25,-166l10,-18C95,483 133,490 161,490C230,490 274,446 274,386C274,325 235,281 162,280C119,280 79,298 56,328l-18,-15C63,279 111,257 162,257C245,257 298,308 298,386C298,456 250,511 161,511z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2076",
    horizAdvX: 374,
    d: "M180,524C163,524 146,521 131,515l92,135l-27,0l-124,-180C57,447 48,420 48,388C48,308 105,252 180,252C255,252 312,308 312,388C312,469 255,524 180,524M180,276C118,276 71,321 71,388C71,456 118,501 180,501C242,501 289,456 289,388C289,321 242,276 180,276z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2077",
    horizAdvX: 304,
    d: "M60,258l25,0l172,372l0,19l-228,0l0,-22l201,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2078",
    horizAdvX: 375,
    d: "M239,461C286,477 307,513 307,553C307,604 269,655 180,655C93,655 54,604 54,553C54,513 75,477 122,461C73,444 48,405 48,362C48,298 93,252 180,252C269,252 313,298 313,362C313,405 288,444 239,461M77,553C77,593 107,634 180,634C254,634 284,593 284,553C284,507 254,472 180,472C107,472 77,507 77,553M180,274C107,274 72,311 72,363C72,410 107,451 180,451C254,451 289,410 289,363C289,310 254,274 180,274z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2079",
    horizAdvX: 374,
    d: "M312,519C312,598 255,655 180,655C105,655 48,598 48,519C48,438 105,383 180,383C197,383 214,386 229,392l-90,-135l28,0l116,174C299,455 312,484 312,519M71,519C71,586 118,631 180,631C241,631 289,586 289,519C289,451 241,406 180,406C118,406 71,451 71,519z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2196",
    horizAdvX: 596,
    d: "M519,215l-399,399l278,0l0,36l-340,0l0,-340l36,0l0,275l398,-397z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2197",
    horizAdvX: 596,
    d: "M179,650l0,-36l277,0l-398,-399l27,-27l398,398l0,-276l36,0l0,340z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2198",
    horizAdvX: 596,
    d: "M483,340l0,-276l-398,398l-27,-27l399,-399l-278,0l0,-36l340,0l0,340z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2199",
    horizAdvX: 596,
    d: "M519,435l-27,27l-398,-397l0,275l-36,0l0,-340l340,0l0,36l-279,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0173",
    horizAdvX: 519,
    d: "M400,-55C400,-30 421,-10 434,0l7,0l0,5C441,6 442,6 442,6l-1,0l0,454l-37,0l0,-282C404,85 340,26 250,26C160,26 95,85 95,178l0,282l-37,0l0,-285C58,52 145,-8 243,-8C309,-8 371,19 404,76l0,-76l1,0C387,-12 369,-33 369,-59C369,-84 390,-114 445,-98l0,29C411,-83 400,-70 400,-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u016F",
    horizAdvX: 519,
    d: "M258,519C295,519 325,547 325,587C325,629 295,656 258,656C221,656 190,629 190,587C190,547 221,519 258,519M258,544C232,544 217,566 217,587C217,608 232,630 258,630C284,630 298,608 298,587C298,566 284,544 258,544M404,460l0,-282C404,85 340,26 250,26C160,26 95,85 95,178l0,282l-37,0l0,-285C58,52 145,-8 243,-8C309,-8 371,19 404,76l0,-76l37,0l0,460z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0169",
    horizAdvX: 519,
    d: "M132,527l29,0C162,551 175,574 202,574C221,574 235,563 248,549C262,533 280,515 313,515C357,515 381,547 383,591l-29,0C353,566 343,544 313,544C290,544 277,559 266,571C251,588 231,603 202,603C163,603 134,570 132,527M404,460l0,-282C404,85 340,26 250,26C160,26 95,85 95,178l0,282l-37,0l0,-285C58,52 145,-8 243,-8C309,-8 371,19 404,76l0,-76l37,0l0,460z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "v",
    horizAdvX: 458,
    d: "M199,0l38,0l183,460l-40,0l-162,-408l-161,408l-39,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "w",
    horizAdvX: 715,
    d: "M637,460l-138,-407l-138,407l-25,0l-140,-407l-137,407l-39,0l155,-460l39,0l135,389l132,-389l39,0l157,460z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u1E83",
    horizAdvX: 715,
    d: "M370,615l-41,-88l36,0l44,88M637,460l-138,-407l-138,407l-25,0l-140,-407l-137,407l-39,0l155,-460l39,0l135,389l132,-389l39,0l157,460z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0175",
    horizAdvX: 715,
    d: "M427,527l-55,88l-49,0l-55,-88l38,0l42,68l41,-68M637,460l-138,-407l-138,407l-25,0l-140,-407l-137,407l-39,0l155,-460l39,0l135,389l132,-389l39,0l157,460z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u1E85",
    horizAdvX: 715,
    d: "M261,524C275,524 288,535 288,551C288,566 275,576 261,576C248,576 235,566 235,551C235,535 248,524 261,524M434,524C448,524 461,535 461,551C461,566 448,576 434,576C421,576 408,566 408,551C408,535 421,524 434,524M637,460l-138,-407l-138,407l-25,0l-140,-407l-137,407l-39,0l155,-460l39,0l135,389l132,-389l39,0l157,460z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u1E81",
    horizAdvX: 715,
    d: "M327,615l-40,0l45,-88l35,0M637,460l-138,-407l-138,407l-25,0l-140,-407l-137,407l-39,0l155,-460l39,0l135,389l132,-389l39,0l157,460z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "x",
    horizAdvX: 475,
    d: "M427,460l-45,0l-154,-201l-155,201l-45,0l177,-230l-177,-230l45,0l155,201l154,-201l45,0l-177,230z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "y",
    horizAdvX: 458,
    d: "M380,460l-162,-408l-161,408l-39,0l181,-459l-73,-185l38,0l256,644z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xFD",
    horizAdvX: 458,
    d: "M240,615l-41,-88l36,0l44,88M380,460l-162,-408l-161,408l-39,0l181,-459l-73,-185l38,0l256,644z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u0177",
    horizAdvX: 458,
    d: "M297,527l-55,88l-49,0l-55,-88l38,0l42,68l41,-68M380,460l-162,-408l-161,408l-39,0l181,-459l-73,-185l38,0l256,644z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xFF",
    horizAdvX: 458,
    d: "M131,524C145,524 158,535 158,551C158,566 145,576 131,576C118,576 105,566 105,551C105,535 118,524 131,524M304,524C318,524 331,535 331,551C331,566 318,576 304,576C291,576 278,566 278,551C278,535 291,524 304,524M380,460l-162,-408l-161,408l-39,0l181,-459l-73,-185l38,0l256,644z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xA5",
    horizAdvX: 563,
    d: "M526,650l-47,0l-207,-318l-207,318l-47,0l228,-349l-175,0l0,-30l182,0l0,-102l-182,0l0,-29l182,0l0,-140l39,0l0,140l181,0l0,29l-181,0l0,102l181,0l0,30l-175,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u1EF3",
    horizAdvX: 458,
    d: "M197,615l-40,0l45,-88l35,0M380,460l-162,-408l-161,408l-39,0l181,-459l-73,-185l38,0l256,644z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "z",
    horizAdvX: 433,
    d: "M376,460l-332,0l0,-34l286,0l-292,-395l0,-31l332,0l0,34l-286,0l292,394z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u017A",
    horizAdvX: 433,
    d: "M229,615l-41,-88l36,0l44,88M376,460l-332,0l0,-34l286,0l-292,-395l0,-31l332,0l0,34l-286,0l292,394z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u017E",
    horizAdvX: 433,
    d: "M248,615l-41,-68l-42,68l-38,0l55,-88l49,0l55,88M376,460l-332,0l0,-34l286,0l-292,-395l0,-31l332,0l0,34l-286,0l292,394z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u017C",
    horizAdvX: 433,
    d: "M207,524C221,524 234,535 234,551C234,566 221,576 207,576C194,576 181,566 181,551C181,535 194,524 207,524M376,460l-332,0l0,-34l286,0l-292,-395l0,-31l332,0l0,34l-286,0l292,394z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 0,
    horizAdvX: 620,
    d: "M305,-8C469,-8 562,132 562,325C562,518 469,658 305,658C142,658 48,518 48,325C48,132 142,-8 305,-8M305,31C166,31 87,153 87,325C87,497 166,618 305,618C445,618 522,497 522,325C522,153 445,31 305,31z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_21_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_162_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_164_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M78.735,15.645c-27.287,0-49.408,22.121-49.408,49.408    c0,9.81,2.863,18.949,7.795,26.635c0.577-0.34,1.158-0.668,1.745-0.984c4.57-2.48,9.333-4.474,14.196-6.137    c4.862-1.668,9.846-2.961,14.932-3.807c0.6-0.101,1.201-0.193,1.804-0.28c-2.07-8.816-4.696-17.529-7.665-26.135    c3.827,8.366,7.024,17.024,9.659,25.877c1.299-0.147,2.606-0.255,3.922-0.312c2.604-0.107,5.257-0.062,7.954,0.586l1.011,0.294    l0.934,0.341c0.625,0.212,1.237,0.485,1.847,0.758c0.616,0.252,1.201,0.61,1.799,0.914c0.575,0.371,1.165,0.702,1.705,1.139    c1.099,0.824,2.115,1.821,2.9,3.004c0.788,1.178,1.323,2.522,1.605,3.867c0.135,0.671,0.229,1.346,0.282,1.992    c0.061,0.639,0.092,1.29,0.181,1.775c0.03,0.248,0.106,0.357,0.102,0.379c0.033,0.001,0.078,0.001,0.116,0.01    c0.387-0.023,0.978-0.274,1.501-0.5c1.086-0.501,2.173-1.133,3.247-1.769c1.081-0.637,2.127-1.297,3.158-1.995    c2.009-1.425,4.009-3.002,5.254-5.098c0.611-1.03,0.979-2.259,0.675-3.446c-0.288-1.182-1.157-2.205-2.223-2.865    c1.119,0.565,2.113,1.515,2.545,2.771c0.449,1.263,0.162,2.681-0.402,3.85c-1.18,2.373-3.149,4.143-5.112,5.772    c-1.004,0.793-2.039,1.563-3.095,2.267c-1.056,0.714-2.113,1.422-3.283,2.052c-0.617,0.296-1.17,0.631-2.044,0.78    c-0.113,0.015-0.25,0.015-0.375,0.018c-0.131-0.003-0.242,0.013-0.408-0.037c-0.154-0.039-0.309-0.086-0.455-0.146    c-0.143-0.087-0.284-0.188-0.413-0.298c-0.446-0.455-0.601-0.955-0.683-1.301c-0.181-0.748-0.232-1.36-0.332-1.972    c-0.087-0.608-0.205-1.178-0.352-1.736c-0.306-1.105-0.765-2.126-1.427-3.017c-0.656-0.893-1.503-1.652-2.45-2.294    c-0.457-0.341-0.987-0.6-1.484-0.893c-0.541-0.238-1.047-0.524-1.612-0.722c-0.553-0.215-1.104-0.433-1.684-0.598l-0.858-0.269    l-0.817-0.195c-2.244-0.416-4.691-0.417-7.113-0.224c-1.06,0.083-2.122,0.206-3.183,0.354c1.276,4.698,2.365,9.459,3.121,14.309    c0.398,2.529,0.677,5.086,0.817,7.667c0.139,2.58,0.135,5.188-0.126,7.813c-0.27,2.619-0.761,5.273-1.777,7.844    c-0.508,1.284-1.168,2.531-1.975,3.707c-0.844,1.148-1.788,2.266-2.953,3.153c-0.943,0.763-1.986,1.375-3.076,1.866    c-1.554,0.999-3.389,1.567-5.317,1.811c-2.24,0.246-4.591,0.065-6.927-0.354c-1.789-0.336-3.577-0.799-5.354-1.351    c-1.008-0.284-2.008-0.589-2.997-0.913c-2.486-0.818-4.853-1.786-7.244-2.831c-2.378-1.054-4.712-2.274-6.962-3.719    c-2.236-1.459-4.428-3.144-6.22-5.432c-1.235-1.501-2.198-3.442-2.618-5.523c-0.095,0.475-0.172,0.956-0.205,1.447    c-0.25,3.157,1.009,6.304,2.822,8.508c1.793,2.288,3.984,3.973,6.22,5.432c2.25,1.445,4.585,2.665,6.962,3.719    c2.391,1.045,4.758,2.014,7.244,2.831c2.478,0.813,5.004,1.551,7.646,1.957c2.633,0.415,5.368,0.589,8.145,0.225    c2.757-0.395,5.6-1.396,7.879-3.241c1.165-0.887,2.109-2.005,2.953-3.153c0.807-1.176,1.466-2.423,1.975-3.707    c1.016-2.571,1.507-5.224,1.777-7.844c0.109-1.093,0.164-2.182,0.192-3.268c0.667,0.027,1.334,0.051,2.007,0.051    c27.287,0,49.408-22.121,49.408-49.408C128.143,37.766,106.023,15.645,78.735,15.645z M68.472,40.47    c-0.192,0.773-0.564,1.354-0.937,1.846c-0.759,0.984-1.642,1.631-2.529,2.21c-0.901,0.552-1.828,1.005-2.782,1.358    c-1.909,0.704-3.884,1.114-5.947,1.169c-1.031,0.031-2.08-0.028-3.163-0.251c-1.083-0.234-2.213-0.555-3.397-1.497    c-0.578-0.476-1.189-1.241-1.393-2.23c-0.134-0.761-0.113-1.346-0.034-1.971c0.195-1.202,0.645-2.321,1.358-3.244    c0.699-0.928,1.624-1.649,2.609-2.1c0.986-0.458,2.018-0.668,3.011-0.71c0.628-0.054,1.043,0.027,1.532,0.091    c0.469,0.071,0.926,0.16,1.38,0.256c0.907,0.195,1.795,0.445,2.673,0.727c-0.921,0.03-1.837,0.068-2.74,0.116    c-0.451,0.025-0.9,0.059-1.339,0.11c-0.418,0.054-0.917,0.116-1.185,0.221c-1.572,0.679-2.752,1.729-3.266,2.961    c-0.269,0.608-0.373,1.272-0.358,1.872c0.022,0.281,0.073,0.611,0.135,0.738c0.002-0.095,0.002-0.118,0.128-0.033    c0.27,0.167,0.943,0.364,1.632,0.458c0.707,0.091,1.482,0.109,2.265,0.079c1.567-0.08,3.197-0.352,4.731-0.804    c0.767-0.226,1.517-0.489,2.205-0.816c0.691-0.307,1.332-0.702,1.781-1.079c0.227-0.187,0.371-0.377,0.455-0.472    c0.082-0.095,0.11-0.098,0.156-0.143c0.065-0.016,0.047-0.158-0.181-0.321c-0.22-0.159-0.56-0.312-0.935-0.423    c-1.551-0.458-3.433-0.562-5.287-0.784c0.855-0.402,1.736-0.718,2.649-0.984c0.916-0.261,1.859-0.456,2.906-0.485    c0.525-0.001,1.083,0.027,1.704,0.214c0.602,0.187,1.369,0.607,1.843,1.414C68.609,38.732,68.676,39.704,68.472,40.47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_163_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M72.979,98.143c-0.512-4.803-1.386-9.591-2.426-14.347    c-0.645,0.113-1.289,0.234-1.932,0.365c-4.837,0.991-9.612,2.389-14.268,4.069c-4.649,1.698-9.186,3.713-13.439,6.138    c-2.121,1.217-4.178,2.522-6.085,3.976c-1.912,1.444-3.658,3.059-5.065,4.829c-1.362,1.776-2.387,3.739-2.481,5.656    c-0.053,0.883,0.074,1.762,0.354,2.621c0.425-1.319,1.193-2.626,2.127-3.845c1.407-1.77,3.154-3.385,5.065-4.829    c1.907-1.454,3.964-2.759,6.085-3.976c0.381-0.217,0.776-0.414,1.162-0.625c7.815,8.645,18.648,14.499,30.835,15.931    c0.071-0.417,0.144-0.833,0.202-1.253C73.754,108.062,73.487,103.078,72.979,98.143z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 146.094,
    y: 50.134,
    style: {
      fill: "none"
    },
    width: 403.906,
    height: 51.199
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 146.0947 92.6561)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Causten-ExtraLight'",
      fontSize: "65.4213px"
    }
  }, "Juliana Varela"));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e150315b55c82dc991ddfcbea068e3f1.svg";
export { ForwardRef as ReactComponent };